webpackJsonp([6],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	__webpack_require__(22);
	__webpack_require__(3);
	
	__webpack_require__(21);
	__webpack_require__(5);
	__webpack_require__(126);
	__webpack_require__(119);
	__webpack_require__(18);
	__webpack_require__(16);
	__webpack_require__(15);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * options properties:
	 *   - columns: slick grid column definitions
	 *   - target: selector to place grid into
	 *   - editable: enable cell editing
	 *   - updatePath: given an id, returns a url to update an item
	 *   - updateParam: the param name to place attributes under for updating (route/event/etc)
	 *   - viewPath: given an item, returns a url to view item
	 *   - ignoreCaseOnSort: when sorting by this column, sort case insensitive
	 */
	var FilteringGridWithBulkOperations = exports.FilteringGridWithBulkOperations = function () {
	  function FilteringGridWithBulkOperations(data, _ref) {
	    var _this = this;
	
	    var columns = _ref.columns,
	        target = _ref.target,
	        _ref$editable = _ref.editable,
	        editable = _ref$editable === undefined ? false : _ref$editable,
	        updatePath = _ref.updatePath,
	        updateParam = _ref.updateParam,
	        viewPath = _ref.viewPath,
	        viewFormatter = _ref.viewFormatter,
	        editPath = _ref.editPath,
	        _ref$ignoreCaseOnSort = _ref.ignoreCaseOnSort,
	        ignoreCaseOnSort = _ref$ignoreCaseOnSort === undefined ? [] : _ref$ignoreCaseOnSort,
	        filterAccessors = _ref.filterAccessors,
	        settingsOpts = _ref.settingsOpts,
	        stickySortFn = _ref.stickySortFn;
	
	    _classCallCheck(this, FilteringGridWithBulkOperations);
	
	    var cbSelector = void 0;
	    this._requestErrorListeners = [];
	    this._updateDoneListeners = {};
	    this._noFilterQueryParams = {};
	
	    // if grid is editable, add a checkbox column to allow bulk operations
	    if (editable) {
	      cbSelector = new Slick.CheckboxSelectColumn({ cssClass: 'slick-cell-checkboxsel' });
	      columns.unshift(cbSelector.getColumnDefinition());
	    }
	    if (viewPath || viewFormatter) {
	      var defaultFormatter = function defaultFormatter(row, cell, val, col, item) {
	        return '<a class="row-link" href="' + viewPath(item) + '">View</a>';
	      };
	      columns.push({
	        id: "view", name: 'View', field: "view", width: 63, resizable: false,
	        formatter: viewFormatter ? viewFormatter : defaultFormatter
	      });
	    }
	    if (editable && editPath) {
	      columns.push({
	        id: "edit", name: 'Edit', field: "edit", width: 63, resizable: false,
	        formatter: function formatter(row, cell, val, col, item) {
	          return '<a class="row-link" href="' + editPath(item) + '">Edit</a>';
	        }
	      });
	    }
	
	    // create the slickgrid data view, and the grid
	    var dataView = this.dataView = new Slick.Data.DataView();
	    var autoHeight = data.length < 15;
	    var slickGridOptions = {
	      enableCellNavigation: true,
	      enableColumnReorder: false,
	      editable: editable,
	      asyncEditorLoading: false,
	      autoEdit: false,
	      forceFitColumns: true,
	      autoHeight: autoHeight
	    };
	    if (autoHeight) {
	      $(target).css({ height: 'auto' });
	      $('.modify_grid_height').hide();
	    }
	    if (editable) {
	      columns.forEach(function (col) {
	        if (col.editor) {
	          col.cssClass = 'can-modify';
	        }
	      });
	    }
	    var slickGrid = this.slickGrid = new Slick.Grid(target, this.dataView, columns, slickGridOptions);
	
	    // we want clicks to select a row (the other option is a single cell)
	    slickGrid.setSelectionModel(new Slick.RowSelectionModel({ selectActiveRow: false }));
	
	    // registering the checkbox column ties it into row selection (visually & keeping track of what's selected)
	    if (editable) {
	      slickGrid.registerPlugin(cbSelector);
	    }
	
	    // allows mouseover of truncated cells to display full cell contents
	    slickGrid.registerPlugin(new Slick.AutoTooltips());
	
	    // grid -> dataview bindings
	    slickGrid.onCellChange.subscribe(function (e, args) {
	      var attrs = {},
	          params = { _method: 'put' },
	          field = args.grid.getColumns()[args.cell].field;
	      dataView.updateItem(args.item.id, args.item);
	      attrs[field] = args.item[field];
	      params[updateParam] = attrs;
	      $.post(updatePath(args.item.id), params, function () {});
	    });
	
	    // dataview -> grid bindings
	    dataView.onRowCountChanged.subscribe(function () {
	      slickGrid.updateRowCount();
	      slickGrid.render();
	    });
	    dataView.onRowsChanged.subscribe(function (e, args) {
	      slickGrid.invalidateRows(args.rows);
	      slickGrid.render();
	    });
	
	    // sorting - set up case insensitive sort columns, and bind grid sort action to dataview
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = ignoreCaseOnSort[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var col = _step.value;
	
	        this.sortingFn(col, caseInsensitiveStringSortFn(col));
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    slickGrid.onSort.subscribe(function (e, args) {
	      slickGrid.setSelectedRows([]);
	      if (_.isFunction(stickySortFn)) {
	        dataView.sort(stickySortCompose(stickySortFn, _this.sortingFn(args.sortCol.field), args.sortAsc), args.sortAsc);
	      } else {
	        dataView.sort(_this.sortingFn(args.sortCol.field), args.sortAsc);
	      }
	    });
	
	    // filterAccessors should be a Map of names to accessor methods. Each
	    // method should return the current UI value of the filter when called
	    // without arguments, and set the UI value of the filter to the first
	    // argument when called with one or more arguments
	    this.filterAccessors = filterAccessors;
	
	    dataView.beginUpdate();
	    dataView.setItems(data);
	    dataView.endUpdate();
	
	    // send settings data to the server when club members change table settings
	    // settingsOpts should be an object with the following keys:
	    // - url: The URL to send the data to
	    // - name: The name of this table
	    // - method (optional): HTTP method to send data with
	    if (settingsOpts) {
	      this.settingsOpts = settingsOpts;
	
	      slickGrid.onColumnsResized.subscribe(function () /*event, args*/{
	        var changes = slickGrid.getColumns().reduce(function (result, column) {
	          result[column.field] = column.width;return result;
	        }, {});
	
	        if (Object.keys(changes).length > 0) {
	          _this.sendSettings({ columnWidths: changes });
	        }
	      });
	
	      slickGrid.onSort.subscribe(function (event, args) {
	        _this.sendSettings({ sortAsc: args.sortAsc, sortCol: args.sortCol.field });
	      });
	    }
	
	    this._stickySortFn = stickySortFn;
	
	    // Disable editing properties of items that are locked
	    slickGrid.onBeforeEditCell.subscribe(function (e, args) {
	      if (args.item.locked) {
	        return false;
	      }
	    });
	  }
	
	  // setter/getter for sorting functions by column name.
	  // uses comparison operators against column field by default
	
	
	  _createClass(FilteringGridWithBulkOperations, [{
	    key: 'sortingFn',
	    value: function sortingFn(col, fn) {
	      if (!this._sortFnCache) this._sortFnCache = {};
	
	      if (!this._sortFnCache[col]) {
	        this._sortFnCache[col] = fn || basicSortFn(col);
	      }
	      return this._sortFnCache[col];
	    }
	  }, {
	    key: 'setSort',
	    value: function setSort(column, asc) {
	      if (_.isFunction(this._stickySortFn)) {
	        this.dataView.sort(stickySortCompose(this._stickySortFn, this.sortingFn(column), asc), asc);
	      } else {
	        this.dataView.sort(this.sortingFn(column), asc);
	      }
	
	      this.slickGrid.setSortColumn(column, asc);
	    }
	
	    /*
	     * Bulk operations
	     */
	
	  }, {
	    key: 'enableBulkOperations',
	    value: function enableBulkOperations(_ref2) {
	      var bulkUpdateAttributePath = _ref2.bulkUpdateAttributePath,
	          bulkDeletePath = _ref2.bulkDeletePath,
	          idsParam = _ref2.idsParam;
	
	      this._bulkUpdateAttributePath = bulkUpdateAttributePath;
	      this._bulkDeletePath = bulkDeletePath;
	      this._bulkUpdateIdsParam = idsParam;
	    }
	
	    // update on server, set attr=value in dataview, update grid
	    // optional updateFn will get called with item and can modify additional fields on item during update
	
	  }, {
	    key: 'setAttributeOnSelectedItems',
	    value: function setAttributeOnSelectedItems(attr, value, updateFn) {
	      var _this2 = this;
	
	      var self = this;
	      return this.remoteRequest({
	        url: this._bulkUpdateAttributePath,
	        params: function params(selectedIds) {
	          return _defineProperty({ attr: attr, value: value }, _this2._bulkUpdateIdsParam, selectedIds.join(','));
	        },
	        done: function done(dataView) {
	          // TODO: Read values from result data. Will require a mapper to get an
	          // array of items from various json structures
	          dataView.beginUpdate();
	          self.selectedItems.forEach(function (item) {
	            item[attr] = value;
	            if (updateFn) {
	              updateFn(item);
	            }
	            dataView.updateItem(item.id, item);
	          });
	          dataView.endUpdate();
	        }
	      });
	    }
	  }, {
	    key: 'deleteSelectedItems',
	    value: function deleteSelectedItems() {
	      var _this3 = this;
	
	      var self = this;
	      var selectedIds = this.selectedItems.map(function (_ref4) {
	        var id = _ref4.id;
	        return id;
	      });
	
	      this.remoteRequest({
	        url: this._bulkDeletePath,
	        params: function params(selectedIds) {
	          return _defineProperty({}, _this3._bulkUpdateIdsParam, selectedIds.join(','));
	        },
	        done: function done(dataView) {
	          // TODO: Read deleted items from returned data
	          dataView.beginUpdate();
	          selectedIds.forEach(function (id) {
	            return dataView.deleteItem(id);
	          });
	          dataView.endUpdate();
	          self.slickGrid.setSelectedRows([]);
	        }
	      });
	    }
	
	    // opts must be an object with the following keys:
	    // - url: endpoint of the remote url
	    // optional keys:
	    // - params: params to send to the remote endpoint. if params is a function,
	    //   it will be called with an array of selected ids and the return value will
	    //   be used as the params for the remote request
	    // - done: a function that takes two parameters, dataView and data, with data
	    //   being the response from the remote endpoint
	    // - fail: called with a list of errors if the request fails
	    // - always: always called when request has completed successfully or not
	    // - skipFailListeners: if true, does not notify onRequestError listeners on
	    //   request failure
	
	  }, {
	    key: 'remoteRequest',
	    value: function remoteRequest(opts) {
	      var self = this;
	      var ids = this.selectedItems.map(function (_ref6) {
	        var id = _ref6.id;
	        return id;
	      });
	      var params = typeof opts.params === "function" ? opts.params(ids) : opts.params || {};
	      var done = opts.done || function () {};
	
	      return $.post(opts.url, params).done(function (data) {
	        return done(self.dataView, data);
	      }).fail(function (xhr) {
	        self._requestFail(xhr, opts.fail, opts.skipFailListeners);
	      }).always(function () {
	        opts.always && opts.always();
	      });
	    }
	
	    // Adds a handler that gets called when any remote request fails
	
	  }, {
	    key: 'onRequestError',
	    value: function onRequestError(handler) {
	      this._requestErrorListeners.push(handler);
	    }
	
	    // Internal helper that alerts listeners to failed remote requests
	
	  }, {
	    key: '_requestFail',
	    value: function _requestFail(xhr, extraCallback, skipListeners) {
	      var errors = [];
	      var data = xhr.responseJSON;
	      if (data) {
	        if (data.errors) {
	          errors = data.errors;
	        } else if (data.error) {
	          errors = [data.error];
	        }
	      }
	
	      if (!skipListeners) {
	        this._requestErrorListeners.forEach(function (listener) {
	          return listener(errors);
	        });
	      }
	
	      if (extraCallback) {
	        extraCallback(errors);
	      }
	    }
	
	    // returns all checked off items when used in editable mode (where checkboxes are present)
	
	  }, {
	    key: 'setSelectedRows',
	    value: function setSelectedRows(rows) {
	      return this.slickGrid.setSelectedRows(rows);
	    }
	
	    /*
	     * Filtering
	     *
	     * Example:
	     *
	     * let grid = new FilteringGridWithBulkOperations(data, opts);
	     * grid.enableFiltering([ {field: 'name', type: 'string'} ]);
	     * grid.filter('name', 'Foo'); //-> only shows items with Foo in name
	     *
	     */
	
	    // filterSpec should look like this: [ {field: 'fieldname', type: 'string'}, ...]
	    // once called, use filter(field, value) to perform filtering
	    //
	    // supported types:
	    //   - string: case-insensitive substring matching
	    //   - array: includes check, use special value "_empty" to match empty arrays
	    //   - range: numeric range filtering by calling filter(field, low, high)
	    //   - anyString: string OR match against array of fields in 'extra'
	    //   - function: 'extra' is a function that tests item, expects bool-like return
	
	  }, {
	    key: 'enableFiltering',
	    value: function enableFiltering(filterSpec) {
	      this._filterSpec = filterSpec;
	
	      // initialize all filter keys to []
	      this._filterValues = filterSpec.reduce(function (acc, _ref7) {
	        var field = _ref7.field;
	        acc[field] = [];return acc;
	      }, {});
	      this.dataView.setFilter(this._filterIncludesItem.bind(this));
	      this._applyFiltersFromUrl();
	    }
	
	    // set a filter, and update grid to only display items that pass filters
	
	  }, {
	    key: 'filter',
	    value: function filter(field) {
	      for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        rest[_key - 1] = arguments[_key];
	      }
	
	      // assumes a string for now with the toLowerCase call
	      this._filterValues[field] = rest;
	      this._refreshFilters();
	      (this._filterChangeListeners || []).forEach(function (listener) {
	        return listener(_defineProperty({}, field, rest));
	      });
	    }
	
	    // registers a callback to be called when a filter changes. The callback
	    // should take a single argument, which is an object with field names for
	    // keys and filter values for values
	
	  }, {
	    key: 'onFilterChange',
	    value: function onFilterChange(func) {
	      if (!this._filterChangeListeners) {
	        this._filterChangeListeners = [];
	      }
	      this._filterChangeListeners.push(func);
	    }
	
	    // returns with current filters as an object with field name keys and filter
	    // value values
	
	  }, {
	    key: 'getFilters',
	    value: function getFilters() {
	      return this._filterValues;
	    }
	
	    // applies filters found in the location hash
	
	  }, {
	    key: '_applyFiltersFromUrl',
	    value: function _applyFiltersFromUrl() {
	      var _this4 = this;
	
	      var persistParams = rwgps.Utils.getQueryParameters();
	      var urlFilters = {};
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var _step2$value = _slicedToArray(_step2.value, 2),
	              key = _step2$value[0],
	              value = _step2$value[1];
	
	          value = decodeURIComponent(value);
	          var specs = _this4._filterSpec.filter(function (spec) {
	            return spec.field === key;
	          });
	          if (specs.length) {
	            var filterSpec = specs[0];
	            var parsedFilter = void 0,
	                tmp = void 0;
	            switch (filterSpec.type) {
	              case 'range':
	                parsedFilter = [0, Infinity];
	                tmp = value.split(',');
	                if (jQuery.isNumeric(tmp[0])) parsedFilter[0] = parseInt(tmp[0]);
	                if (tmp[1] && jQuery.isNumeric(tmp[1])) parsedFilter[1] = parseInt(tmp[1]);
	                break;
	              case 'arraySubset':
	                parsedFilter = value.split(',');
	                break;
	              default:
	                parsedFilter = value;
	                break;
	            }
	            if (parsedFilter) {
	              urlFilters[key] = parsedFilter;
	            }
	          } else if (key.length) {
	            // Keep track of query param that is not a filter (e.g. ?archive=true)
	            _this4._noFilterQueryParams[key] = value;
	          }
	        };
	
	        for (var _iterator2 = Object.entries(persistParams)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.setFilters(urlFilters);
	    }
	
	    // updates location hash with current filters
	
	  }, {
	    key: '_persistFiltersToUrl',
	    value: function _persistFiltersToUrl(filters) {
	      var _this5 = this;
	
	      var persistFilters = {};
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        var _loop2 = function _loop2() {
	          var _step3$value = _slicedToArray(_step3.value, 2),
	              key = _step3$value[0],
	              value = _step3$value[1];
	
	          var filterSpec = _this5._filterSpec.filter(function (spec) {
	            return spec.field === key;
	          })[0];
	          var persistValue = void 0;
	          switch (filterSpec.type) {
	            case 'range':
	              if (value[0] !== 0 || value[1] !== Infinity) {
	                persistValue = value[1] === Infinity ? [value[0]] : value;
	              }
	              break;
	            default:
	              if (value.length) persistValue = value;
	              break;
	          }
	          if (persistValue) persistFilters[key] = persistValue;
	        };
	
	        for (var _iterator3 = Object.entries(filters)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          _loop2();
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      var allParams = Object.assign({}, persistFilters, this._noFilterQueryParams);
	      var queryString = Object.keys(allParams).map(function (k) {
	        return k + '=' + encodeURIComponent(allParams[k].toString());
	      }).join('&');
	      window.history.replaceState({}, document.title, '?' + queryString);
	    }
	
	    // sets the current filters in bulk, refreshes the data view, and sets the
	    // filter inputs in the UI
	
	  }, {
	    key: 'setFilters',
	    value: function setFilters(filters) {
	      var _this6 = this;
	
	      var triggerListeners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var setInputs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      filters = Object.assign(filters); // Grab a copy so we can modify without worry
	
	      if (setInputs) {
	        this.filterAccessors.forEach(function (accessor, field) {
	          return accessor(filters[field]);
	        });
	      }
	
	      Object.keys(this._filterValues).forEach(function (key) {
	        var newValue = filters[key] || null;
	        if (newValue === null) {
	          newValue = [];
	        } // Rails munges empty arrays to nil, so convert them back
	        if (!Array.isArray(newValue)) {
	          newValue = [newValue];
	        }
	        _this6._filterValues[key] = newValue;
	      });
	
	      this._refreshFilters();
	
	      if (triggerListeners) {
	        (this._filterChangeListeners || []).forEach(function (listener) {
	          return listener(filters);
	        });
	      }
	      this._persistFiltersToUrl(filters);
	    }
	
	    // Call this function when filter inputs have changed and should be re-read
	
	  }, {
	    key: 'filterInputsChanged',
	    value: function filterInputsChanged() {
	      var filters = {};
	      this.filterAccessors.forEach(function (accessor, field) {
	        return filters[field] = accessor();
	      });
	      this.setFilters(filters, true, false);
	    }
	  }, {
	    key: 'sendSettings',
	    value: function sendSettings(data) {
	      var opts = this.settingsOpts;
	      $.ajax({
	        url: opts.url,
	        method: opts.method || "PUT",
	        data: JSON.stringify({ table_settings: _defineProperty({}, opts.name, data) }),
	        contentType: "application/json"
	      });
	    }
	
	    // internal helper
	
	  }, {
	    key: '_refreshFilters',
	    value: function _refreshFilters() {
	      this.slickGrid.setSelectedRows([]);
	      this.dataView.setFilterArgs(this._filterValues);
	      this.dataView.refresh();
	    }
	
	    // internal helper to check if an item should be displayed or hidden based on the current filter criteria
	
	  }, {
	    key: '_filterIncludesItem',
	    value: function _filterIncludesItem(item, args) {
	      // no filter args on initial data load - show everything
	      if (!args) return true;
	
	      var testVal = void 0;
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        var _loop3 = function _loop3() {
	          var _step4$value = _step4.value,
	              field = _step4$value.field,
	              type = _step4$value.type,
	              extra = _step4$value.extra;
	
	          var doesMatch = false;
	          switch (type) {
	            case 'string':
	              testVal = (args[field][0] || '').toLowerCase();
	              if (!(item[field] || '').toLowerCase().includes(testVal)) return {
	                  v: false
	                };
	              break;
	            case 'array':
	              testVal = args[field][0];
	              if (!(!testVal || item[field].includes(testVal) || testVal == '_empty' && !item[field].length)) return {
	                  v: false
	                };
	              break;
	            case 'arraySubset':
	              // The item will be filtered out unless testVal (an array of strings)
	              // is a subset of item[field] (an array of strings)
	              testVal = args[field];
	              if (!(!testVal || testVal.every(function (str) {
	                return item[field].indexOf(str) >= 0;
	              }))) return {
	                  v: false
	                };
	              break;
	            case 'range':
	              if (item[field] < args[field][0] || item[field] > args[field][1]) return {
	                  v: false
	                };
	              break;
	            case 'anyString':
	              var _iteratorNormalCompletion5 = true;
	              var _didIteratorError5 = false;
	              var _iteratorError5 = undefined;
	
	              try {
	                for (var _iterator5 = extra[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                  var subField = _step5.value;
	
	                  testVal = (args[field][0] || '').toLowerCase();
	                  if ((item[subField] || '').toLowerCase().includes(testVal)) doesMatch = true;
	                }
	              } catch (err) {
	                _didIteratorError5 = true;
	                _iteratorError5 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                    _iterator5.return();
	                  }
	                } finally {
	                  if (_didIteratorError5) {
	                    throw _iteratorError5;
	                  }
	                }
	              }
	
	              if (!doesMatch) return {
	                  v: false
	                };
	              break;
	            case 'function':
	              if (!extra(item, args[field][0])) return {
	                  v: false
	                };
	          }
	        };
	
	        for (var _iterator4 = this._filterSpec[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var _ret3 = _loop3();
	
	          if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: 'selectedItems',
	    get: function get() {
	      var _this7 = this;
	
	      return this.slickGrid.getSelectedRows().map(function (i) {
	        return _this7.dataView.getItem(i);
	      });
	    }
	  }]);
	
	  return FilteringGridWithBulkOperations;
	}();
	
	FilteringGridWithBulkOperations.formatters = {
	  visibility: function visibility(row, cell, value) {
	    if (value == 0) {
	      return 'Public';
	    } else if (value == 1) {
	      return 'Managers';
	    } else if (value == 2) {
	      return 'Members';
	    }
	  },
	  // must be bound to view so it can check this.userDateFormat
	  date: function date(row, cell, value) {
	    if (value == null) return;
	    if (typeof value === "string") {
	      value = value.indexOf('T') === -1 ? rwgps.DateExt.parseDate(value) : rwgps.DateExt.parse(value);
	    }
	
	    if (this.userDateFormat == "ymd") {
	      return value.strftime("%y/%m/%d");
	    } else if (this.userDateFormat == "dmy") {
	      return value.strftime("%d/%m/%y");
	    } else {
	      return value.strftime("%m/%d/%y");
	    }
	  },
	  tags: function tags(row, cell, value, col, item) {
	    return (item.tag_names || []).join(', ');
	  },
	  genericArray: function genericArray(row, cell, value) {
	    return (value || []).join(', ');
	  },
	  distance: function distance(row, cell, value) {
	    return rwgps.LabelMaker.longLabel(value);
	  },
	  elevationGain: function elevationGain(row, cell, value) {
	    return rwgps.LabelMaker.shortLabel(value);
	  },
	  checkbox: function checkbox(row, cell, value) {
	    return '<input type="checkbox" ' + (value && 'checked') + ' class="grid_checkbox">';
	  },
	  boolToYN: function boolToYN(row, cell, value) {
	    if (value) {
	      return "Yes";
	    } else {
	      return "No";
	    }
	  },
	  capitalize: function capitalize(row, cell, value) {
	    return value[0].toUpperCase() + value.slice(1);
	  },
	  info: function info(row, cell, value, col, item) {
	    if (item.locked) {
	      return '<a href="#" class="route-info" data-toggle="modal" data-id=' + item.id + ' style="color:#f80;"><i style="font-size:16px" class="icon-lock"></i></a>';
	    } else {
	      return '<a href="#" class="route-info" data-toggle="modal" data-id=' + item.id + ' style="color:#f80;"><span style="font-size:16px" class="icon-info-sign"></span></a>';
	    }
	  },
	  routeLink: function routeLink(row, cell, value, col, item) {
	    var color = rwgps.hasRouteLink[item.id] ? '#f80' : '#ccc';
	    return '<a href="#" class="route-link" data-toggle="modal" data-id=' + item.id + ' style="color:' + color + ';"><span style="font-size:16px" class="icon-link"></span></a>';
	  },
	  // must be bound to view so it can check this.userPinnedRoutes
	  pin: function pin(row, cell, value, col, item) {
	    var userPinnedRoutes = this.userPinnedRoutes || [];
	    var match = 0;
	    for (var i = 0; i < userPinnedRoutes.length; i++) {
	      if (item.id == userPinnedRoutes[i].object_id) {
	        match += 1;
	      }
	    }
	    if (match > 0) {
	      return "";
	    } else {
	      return '<a class="remember_this" style="color:#f80;" href="/remember/route/' + item.id + '"><span class="icon icon-pin" style="font-size:20px"></span></a>';
	    }
	  },
	  // must be bound to view so it can check this.editable
	  routeName: function routeName(row, cell, value, col, item) {
	    var text = _.escape(value);
	
	    var previewAttributes = 'class="showPreview" data-id="' + item.id + '" data-type="route" data-name="' + item.name + '" data-elevationGain="' + item.elevation_gain + '" data-elevationLoss="' + item.elevation_loss + '" data-distance="' + item.distance + '" data-privacyCode="' + item.privacyCode + '"';
	
	    if (this.editable) {
	      var result = '';
	      if (item.locked) {
	        result += '<i class="icon-lock icon-large"></i> ';
	      }
	      return '<span ' + previewAttributes + '>' + result + text + '</span>';
	    } else {
	      var url = "/routes/" + item.id;
	      if (item.privacy_code_string) {
	        url += "?privacy_code=" + item.privacy_code_string;
	      }
	      return '<a href="' + url + '" ' + previewAttributes + '>' + text + '</a>';
	    }
	  },
	  // must be bound to view so it can check this.editable
	  eventName: function eventName(row, cell, value, colDef, item) {
	    var out = "";
	    if (!this.editable) {
	      var url = "/events/" + item.slug;
	      out += '<a href="' + url + '">';
	    }
	    out += _.escape(value);
	    if (!this.editable) {
	      out += '</a>';
	    }
	    return out;
	  }
	};
	
	/*
	 * utilities to generate sorting functions
	 */
	
	function caseInsensitiveStringSortFn(col) {
	  return function (a, b) {
	    var x = (a[col] || '').toUpperCase(),
	        y = (b[col] || '').toUpperCase();
	    return x == y ? 0 : x > y ? 1 : -1;
	  };
	}
	
	function basicSortFn(col) {
	  return function (a, b) {
	    var x = a[col],
	        y = b[col];
	
	    // Handle null/undefined values
	    if (x == null && y == null) return 0;
	    if (x == null) return -1;
	    if (y == null) return 1;
	
	    return x == y ? 0 : x > y ? 1 : -1;
	  };
	}
	
	function stickySortCompose(stickyFn, regularFn, sortAsc) {
	  return function (a, b) {
	    var stickyResult = stickyFn(a, b);
	    if (stickyResult === 0) {
	      return regularFn(a, b);
	    }
	    // No matter the sort direction, sticky is always first
	    return sortAsc ? -1 * stickyResult : stickyResult;
	  };
	}

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	/*!
	 * jquery-timepicker v1.8.2 - A jQuery timepicker plugin inspired by Google Calendar. It supports both mouse and keyboard navigation.
	 * Copyright (c) 2015 Jon Thornton - http://jonthornton.github.com/jquery-timepicker/
	 * License: MIT
	 */
	
	
	(function (factory) {
			factory(jQuery);
	}(function ($) {
		var _baseDate = _generateBaseDate();
		var _ONE_DAY = 86400;
		var _lang = {
			am: 'am',
			pm: 'pm',
			AM: 'AM',
			PM: 'PM',
			decimal: '.',
			mins: 'mins',
			hr: 'hr',
			hrs: 'hrs'
		};
	
		var methods = {
			init: function(options)
			{
				return this.each(function()
				{
					var self = $(this);
	
					// pick up settings from data attributes
					var attributeOptions = [];
					for (var key in $.fn.timepicker.defaults) {
						if (self.data(key))  {
							attributeOptions[key] = self.data(key);
						}
					}
	
					var settings = $.extend({}, $.fn.timepicker.defaults, attributeOptions, options);
	
					if (settings.lang) {
						_lang = $.extend(_lang, settings.lang);
					}
	
					settings = _parseSettings(settings);
					self.data('timepicker-settings', settings);
					self.addClass('ui-timepicker-input');
	
					if (settings.useSelect) {
						_render(self);
					} else {
						self.prop('autocomplete', 'off');
						if (settings.showOn) {
							for (var i in settings.showOn) {
								self.on(settings.showOn[i]+'.timepicker', methods.show);
							}
						}
						self.on('change.timepicker', _formatValue);
						self.on('keydown.timepicker', _keydownhandler);
						self.on('keyup.timepicker', _keyuphandler);
						if (settings.disableTextInput) {
							self.on('keypress.timepicker', function(e) { e.preventDefault(); });
						}
	
						_formatValue.call(self.get(0));
					}
				});
			},
	
			show: function(e)
			{
				var self = $(this);
				var settings = self.data('timepicker-settings');
	
				if (e) {
					e.preventDefault();
				}
	
				if (settings.useSelect) {
					self.data('timepicker-list').focus();
					return;
				}
	
				if (_hideKeyboard(self)) {
					// block the keyboard on mobile devices
					self.blur();
				}
	
				var list = self.data('timepicker-list');
	
				// check if input is readonly
				if (self.prop('readonly')) {
					return;
				}
	
				// check if list needs to be rendered
				if (!list || list.length === 0 || typeof settings.durationTime === 'function') {
					_render(self);
					list = self.data('timepicker-list');
				}
	
				if (_isVisible(list)) {
					return;
				}
	
				self.data('ui-timepicker-value', self.val());
				_setSelected(self, list);
	
				// make sure other pickers are hidden
				methods.hide();
	
				// position the dropdown relative to the input
				list.show();
				var listOffset = {};
	
				if (settings.orientation.match(/r/)) {
					// right-align the dropdown
					listOffset.left = self.offset().left + self.outerWidth() - list.outerWidth() + parseInt(list.css('marginLeft').replace('px', ''), 10);
				} else {
					// left-align the dropdown
					listOffset.left = self.offset().left + parseInt(list.css('marginLeft').replace('px', ''), 10);
				}
	
				var verticalOrientation;
				if (settings.orientation.match(/t/)) {
					verticalOrientation = 't';
				} else if (settings.orientation.match(/b/)) {
					verticalOrientation = 'b';
				} else if ((self.offset().top + self.outerHeight(true) + list.outerHeight()) > $(window).height() + $(window).scrollTop()) {
					verticalOrientation = 't';
				} else {
					verticalOrientation = 'b';
				}
	
				if (verticalOrientation == 't') {
					// position the dropdown on top
					list.addClass('ui-timepicker-positioned-top');
					listOffset.top = self.offset().top - list.outerHeight() + parseInt(list.css('marginTop').replace('px', ''), 10);
				} else {
					// put it under the input
					list.removeClass('ui-timepicker-positioned-top');
					listOffset.top = self.offset().top + self.outerHeight() + parseInt(list.css('marginTop').replace('px', ''), 10);
				}
	
				list.offset(listOffset);
	
				// position scrolling
				var selected = list.find('.ui-timepicker-selected');
	
				if (!selected.length) {
					if (_getTimeValue(self)) {
						selected = _findRow(self, list, _time2int(_getTimeValue(self)));
					} else if (settings.scrollDefault) {
						selected = _findRow(self, list, settings.scrollDefault());
					}
				}
	
				if (selected && selected.length) {
					var topOffset = list.scrollTop() + selected.position().top - selected.outerHeight();
					list.scrollTop(topOffset);
				} else {
					list.scrollTop(0);
				}
	
				// prevent scroll propagation
				if(settings.stopScrollPropagation) {
					$(document).on('wheel.ui-timepicker', '.ui-timepicker-wrapper', function(e){
						e.preventDefault();
						var currentScroll = $(this).scrollTop();
						$(this).scrollTop(currentScroll + e.originalEvent.deltaY);
					});
				}
	
				// attach close handlers
				$(document).on('touchstart.ui-timepicker mousedown.ui-timepicker', _closeHandler);
				$(window).on('resize.ui-timepicker', _closeHandler);
				if (settings.closeOnWindowScroll) {
					$(document).on('scroll.ui-timepicker', _closeHandler);
				}
	
				self.trigger('showTimepicker');
	
				return this;
			},
	
			hide: function(e)
			{
				var self = $(this);
				var settings = self.data('timepicker-settings');
	
				if (settings && settings.useSelect) {
					self.blur();
				}
	
				$('.ui-timepicker-wrapper').each(function() {
					var list = $(this);
					if (!_isVisible(list)) {
						return;
					}
	
					var self = list.data('timepicker-input');
					var settings = self.data('timepicker-settings');
	
					if (settings && settings.selectOnBlur) {
						_selectValue(self);
					}
	
					list.hide();
					self.trigger('hideTimepicker');
				});
	
				return this;
			},
	
			option: function(key, value)
			{
				return this.each(function(){
					var self = $(this);
					var settings = self.data('timepicker-settings');
					var list = self.data('timepicker-list');
	
					if (typeof key == 'object') {
						settings = $.extend(settings, key);
	
					} else if (typeof key == 'string' && typeof value != 'undefined') {
						settings[key] = value;
	
					} else if (typeof key == 'string') {
						return settings[key];
					}
	
					settings = _parseSettings(settings);
	
					self.data('timepicker-settings', settings);
	
					if (list) {
						list.remove();
						self.data('timepicker-list', false);
					}
	
					if (settings.useSelect) {
						_render(self);
					}
				});
			},
	
			getSecondsFromMidnight: function()
			{
				return _time2int(_getTimeValue(this));
			},
	
			getTime: function(relative_date)
			{
				var self = this;
	
				var time_string = _getTimeValue(self);
				if (!time_string) {
					return null;
				}
	
				var offset = _time2int(time_string);
				if (offset === null) {
					return null;
				}
	
				if (!relative_date) {
					relative_date = new Date();
				}
	
				// construct a Date with today's date, and offset's time
				var time = new Date(relative_date);
				time.setHours(offset / 3600);
				time.setMinutes(offset % 3600 / 60);
				time.setSeconds(offset % 60);
				time.setMilliseconds(0);
	
				return time;
			},
	
			setTime: function(value)
			{
				var self = this;
				var settings = self.data('timepicker-settings');
	
				if (settings.forceRoundTime) {
					var prettyTime = _roundAndFormatTime(_time2int(value), settings)
				} else {
					var prettyTime = _int2time(_time2int(value), settings);
				}
	
				if (value && prettyTime === null && settings.noneOption) {
					prettyTime = value;
				}
	
				_setTimeValue(self, prettyTime);
				if (self.data('timepicker-list')) {
					_setSelected(self, self.data('timepicker-list'));
				}
	
				return this;
			},
	
			remove: function()
			{
				var self = this;
	
				// check if this element is a timepicker
				if (!self.hasClass('ui-timepicker-input')) {
					return;
				}
	
				var settings = self.data('timepicker-settings');
				self.removeAttr('autocomplete', 'off');
				self.removeClass('ui-timepicker-input');
				self.removeData('timepicker-settings');
				self.off('.timepicker');
	
				// timepicker-list won't be present unless the user has interacted with this timepicker
				if (self.data('timepicker-list')) {
					self.data('timepicker-list').remove();
				}
	
				if (settings.useSelect) {
					self.show();
				}
	
				self.removeData('timepicker-list');
	
				return this;
			}
		};
	
		// private methods
	
		function _isVisible(elem)
		{
			var el = elem[0];
			return el.offsetWidth > 0 && el.offsetHeight > 0;
		}
	
		function _parseSettings(settings)
		{
			if (settings.minTime) {
				settings.minTime = _time2int(settings.minTime);
			}
	
			if (settings.maxTime) {
				settings.maxTime = _time2int(settings.maxTime);
			}
	
			if (settings.durationTime && typeof settings.durationTime !== 'function') {
				settings.durationTime = _time2int(settings.durationTime);
			}
	
			if (settings.scrollDefault == 'now') {
				settings.scrollDefault = function() {
					return settings.roundingFunction(_time2int(new Date()), settings);
				}
			} else if (settings.scrollDefault && typeof settings.scrollDefault != 'function') {
				var val = settings.scrollDefault;
				settings.scrollDefault = function() {
					return settings.roundingFunction(_time2int(val), settings);
				}
			} else if (settings.minTime) {
				settings.scrollDefault = function() {
					return settings.roundingFunction(settings.minTime, settings);
				}
			}
	
			if ($.type(settings.timeFormat) === "string" && settings.timeFormat.match(/[gh]/)) {
				settings._twelveHourTime = true;
			}
	
			if (settings.showOnFocus === false && settings.showOn.indexOf('focus') != -1) {
				settings.showOn.splice(settings.showOn.indexOf('focus'), 1);
			}
	
			if (settings.disableTimeRanges.length > 0) {
				// convert string times to integers
				for (var i in settings.disableTimeRanges) {
					settings.disableTimeRanges[i] = [
						_time2int(settings.disableTimeRanges[i][0]),
						_time2int(settings.disableTimeRanges[i][1])
					];
				}
	
				// sort by starting time
				settings.disableTimeRanges = settings.disableTimeRanges.sort(function(a, b){
					return a[0] - b[0];
				});
	
				// merge any overlapping ranges
				for (var i = settings.disableTimeRanges.length-1; i > 0; i--) {
					if (settings.disableTimeRanges[i][0] <= settings.disableTimeRanges[i-1][1]) {
						settings.disableTimeRanges[i-1] = [
							Math.min(settings.disableTimeRanges[i][0], settings.disableTimeRanges[i-1][0]),
							Math.max(settings.disableTimeRanges[i][1], settings.disableTimeRanges[i-1][1])
						];
						settings.disableTimeRanges.splice(i, 1);
					}
				}
			}
	
			return settings;
		}
	
		function _render(self)
		{
			var settings = self.data('timepicker-settings');
			var list = self.data('timepicker-list');
	
			if (list && list.length) {
				list.remove();
				self.data('timepicker-list', false);
			}
	
			if (settings.useSelect) {
				list = $('<select />', { 'class': 'ui-timepicker-select' });
				var wrapped_list = list;
			} else {
				list = $('<ul />', { 'class': 'ui-timepicker-list' });
	
				var wrapped_list = $('<div />', { 'class': 'ui-timepicker-wrapper', 'tabindex': -1 });
				wrapped_list.css({'display':'none', 'position': 'absolute' }).append(list);
			}
	
			if (settings.noneOption) {
				if (settings.noneOption === true) {
					settings.noneOption = (settings.useSelect) ? 'Time...' : 'None';
				}
	
				if ($.isArray(settings.noneOption)) {
					for (var i in settings.noneOption) {
						if (parseInt(i, 10) == i){
							var noneElement = _generateNoneElement(settings.noneOption[i], settings.useSelect);
							list.append(noneElement);
						}
					}
				} else {
					var noneElement = _generateNoneElement(settings.noneOption, settings.useSelect);
					list.append(noneElement);
				}
			}
	
			if (settings.className) {
				wrapped_list.addClass(settings.className);
			}
	
			if ((settings.minTime !== null || settings.durationTime !== null) && settings.showDuration) {
				var stepval = typeof settings.step == 'function' ? 'function' : settings.step;
				wrapped_list.addClass('ui-timepicker-with-duration');
				wrapped_list.addClass('ui-timepicker-step-'+settings.step);
			}
	
			var durStart = settings.minTime;
			if (typeof settings.durationTime === 'function') {
				durStart = _time2int(settings.durationTime());
			} else if (settings.durationTime !== null) {
				durStart = settings.durationTime;
			}
			var start = (settings.minTime !== null) ? settings.minTime : 0;
			var end = (settings.maxTime !== null) ? settings.maxTime : (start + _ONE_DAY - 1);
	
			if (end < start) {
				// make sure the end time is greater than start time, otherwise there will be no list to show
				end += _ONE_DAY;
			}
	
			if (end === _ONE_DAY-1 && $.type(settings.timeFormat) === "string" && settings.show2400) {
				// show a 24:00 option when using military time
				end = _ONE_DAY;
			}
	
			var dr = settings.disableTimeRanges;
			var drCur = 0;
			var drLen = dr.length;
	
			var stepFunc = settings.step;
			if (typeof stepFunc != 'function') {
				stepFunc = function() {
					return settings.step;
				}
			}
	
			for (var i=start, j=0; i <= end; j++, i += stepFunc(j)*60) {
				var timeInt = i;
				var timeString = _int2time(timeInt, settings);
	
				if (settings.useSelect) {
					var row = $('<option />', { 'value': timeString });
					row.text(timeString);
				} else {
					var row = $('<li />');
					row.data('time', (timeInt <= 86400 ? timeInt : timeInt % 86400));
					row.text(timeString);
				}
	
				if ((settings.minTime !== null || settings.durationTime !== null) && settings.showDuration) {
					var durationString = _int2duration(i - durStart, settings.step);
					if (settings.useSelect) {
						row.text(row.text()+' ('+durationString+')');
					} else {
						var duration = $('<span />', { 'class': 'ui-timepicker-duration' });
						duration.text(' ('+durationString+')');
						row.append(duration);
					}
				}
	
				if (drCur < drLen) {
					if (timeInt >= dr[drCur][1]) {
						drCur += 1;
					}
	
					if (dr[drCur] && timeInt >= dr[drCur][0] && timeInt < dr[drCur][1]) {
						if (settings.useSelect) {
							row.prop('disabled', true);
						} else {
							row.addClass('ui-timepicker-disabled');
						}
					}
				}
	
				list.append(row);
			}
	
			wrapped_list.data('timepicker-input', self);
			self.data('timepicker-list', wrapped_list);
	
			if (settings.useSelect) {
				if (self.val()) {
					list.val(_roundAndFormatTime(_time2int(self.val()), settings));
				}
	
				list.on('focus', function(){
					$(this).data('timepicker-input').trigger('showTimepicker');
				});
				list.on('blur', function(){
					$(this).data('timepicker-input').trigger('hideTimepicker');
				});
				list.on('change', function(){
					_setTimeValue(self, $(this).val(), 'select');
				});
	
				_setTimeValue(self, list.val(), 'initial');
				self.hide().after(list);
			} else {
				var appendTo = settings.appendTo;
				if (typeof appendTo === 'string') {
					appendTo = $(appendTo);
				} else if (typeof appendTo === 'function') {
					appendTo = appendTo(self);
				}
				appendTo.append(wrapped_list);
				_setSelected(self, list);
	
				list.on('mousedown', 'li', function(e) {
	
					// hack: temporarily disable the focus handler
					// to deal with the fact that IE fires 'focus'
					// events asynchronously
					self.off('focus.timepicker');
					self.on('focus.timepicker-ie-hack', function(){
						self.off('focus.timepicker-ie-hack');
						self.on('focus.timepicker', methods.show);
					});
	
					if (!_hideKeyboard(self)) {
						self[0].focus();
					}
	
					// make sure only the clicked row is selected
					list.find('li').removeClass('ui-timepicker-selected');
					$(this).addClass('ui-timepicker-selected');
	
					if (_selectValue(self)) {
						self.trigger('hideTimepicker');
	
						list.on('mouseup.timepicker', 'li', function(e) {
							list.off('mouseup.timepicker');
							wrapped_list.hide();
						});
					}
				});
			}
		}
	
		function _generateNoneElement(optionValue, useSelect)
		{
			var label, className, value;
	
			if (typeof optionValue == 'object') {
				label = optionValue.label;
				className = optionValue.className;
				value = optionValue.value;
			} else if (typeof optionValue == 'string') {
				label = optionValue;
			} else {
				$.error('Invalid noneOption value');
			}
	
			if (useSelect) {
				return $('<option />', {
						'value': value,
						'class': className,
						'text': label
					});
			} else {
				return $('<li />', {
						'class': className,
						'text': label
					}).data('time', value);
			}
		}
	
		function _roundAndFormatTime(seconds, settings)
		{
			seconds = settings.roundingFunction(seconds, settings);
			if (seconds !== null) {
				return _int2time(seconds, settings);
			}
		}
	
		function _generateBaseDate()
		{
			return new Date(1970, 1, 1, 0, 0, 0);
		}
	
		// event handler to decide whether to close timepicker
		function _closeHandler(e)
		{
			var target = $(e.target);
			var input = target.closest('.ui-timepicker-input');
			if (input.length === 0 && target.closest('.ui-timepicker-wrapper').length === 0) {
				methods.hide();
				$(document).unbind('.ui-timepicker');
				$(window).unbind('.ui-timepicker');
			}
		}
	
		function _hideKeyboard(self)
		{
			var settings = self.data('timepicker-settings');
			return ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && settings.disableTouchKeyboard);
		}
	
		function _findRow(self, list, value)
		{
			if (!value && value !== 0) {
				return false;
			}
	
			var settings = self.data('timepicker-settings');
			var out = false;
			var value = settings.roundingFunction(value, settings);
	
			// loop through the menu items
			list.find('li').each(function(i, obj) {
				var jObj = $(obj);
				if (typeof jObj.data('time') != 'number') {
					return;
				}
	
				if (jObj.data('time') == value) {
					out = jObj;
					return false;
				}
			});
	
			return out;
		}
	
		function _setSelected(self, list)
		{
			list.find('li').removeClass('ui-timepicker-selected');
	
			var timeValue = _time2int(_getTimeValue(self), self.data('timepicker-settings'));
			if (timeValue === null) {
				return;
			}
	
			var selected = _findRow(self, list, timeValue);
			if (selected) {
	
				var topDelta = selected.offset().top - list.offset().top;
	
				if (topDelta + selected.outerHeight() > list.outerHeight() || topDelta < 0) {
					list.scrollTop(list.scrollTop() + selected.position().top - selected.outerHeight());
				}
	
				selected.addClass('ui-timepicker-selected');
			}
		}
	
	
		function _formatValue(e, origin)
		{
			if (this.value === '' || origin == 'timepicker') {
				return;
			}
	
			var self = $(this);
	
			if (self.is(':focus') && (!e || e.type != 'change')) {
				return;
			}
	
			var settings = self.data('timepicker-settings');
			var seconds = _time2int(this.value, settings);
	
			if (seconds === null) {
				self.trigger('timeFormatError');
				return;
			}
	
			var rangeError = false;
			// check that the time in within bounds
			if (settings.minTime !== null && seconds < settings.minTime) {
				rangeError = true;
			} else if (settings.maxTime !== null && seconds > settings.maxTime) {
				rangeError = true;
			}
	
			// check that time isn't within disabled time ranges
			$.each(settings.disableTimeRanges, function(){
				if (seconds >= this[0] && seconds < this[1]) {
					rangeError = true;
					return false;
				}
			});
	
			if (settings.forceRoundTime) {
				seconds = settings.roundingFunction(seconds, settings);
			}
	
			var prettyTime = _int2time(seconds, settings);
	
			if (rangeError) {
				if (_setTimeValue(self, prettyTime, 'error')) {
					self.trigger('timeRangeError');
				}
			} else {
				_setTimeValue(self, prettyTime);
			}
		}
	
		function _getTimeValue(self)
		{
			if (self.is('input')) {
				return self.val();
			} else {
				// use the element's data attributes to store values
				return self.data('ui-timepicker-value');
			}
		}
	
		function _setTimeValue(self, value, source)
		{
			if (self.is('input')) {
				self.val(value);
	
				var settings = self.data('timepicker-settings');
				if (settings.useSelect && source != 'select' && source != 'initial') {
					self.data('timepicker-list').val(_roundAndFormatTime(_time2int(value), settings));
				}
			}
	
			if (self.data('ui-timepicker-value') != value) {
				self.data('ui-timepicker-value', value);
				if (source == 'select') {
					self.trigger('selectTime').trigger('changeTime').trigger('change', 'timepicker');
				} else if (source != 'error') {
					self.trigger('changeTime');
				}
	
				return true;
			} else {
				self.trigger('selectTime');
				return false;
			}
		}
	
		/*
		*  Keyboard navigation via arrow keys
		*/
		function _keydownhandler(e)
		{
			var self = $(this);
			var list = self.data('timepicker-list');
	
			if (!list || !_isVisible(list)) {
				if (e.keyCode == 40) {
					// show the list!
					methods.show.call(self.get(0));
					list = self.data('timepicker-list');
					if (!_hideKeyboard(self)) {
						self.focus();
					}
				} else {
					return true;
				}
			}
	
			switch (e.keyCode) {
	
				case 13: // return
					if (_selectValue(self)) {
						methods.hide.apply(this);
					}
	
					e.preventDefault();
					return false;
	
				case 38: // up
					var selected = list.find('.ui-timepicker-selected');
	
					if (!selected.length) {
						list.find('li').each(function(i, obj) {
							if ($(obj).position().top > 0) {
								selected = $(obj);
								return false;
							}
						});
						selected.addClass('ui-timepicker-selected');
	
					} else if (!selected.is(':first-child')) {
						selected.removeClass('ui-timepicker-selected');
						selected.prev().addClass('ui-timepicker-selected');
	
						if (selected.prev().position().top < selected.outerHeight()) {
							list.scrollTop(list.scrollTop() - selected.outerHeight());
						}
					}
	
					return false;
	
				case 40: // down
					selected = list.find('.ui-timepicker-selected');
	
					if (selected.length === 0) {
						list.find('li').each(function(i, obj) {
							if ($(obj).position().top > 0) {
								selected = $(obj);
								return false;
							}
						});
	
						selected.addClass('ui-timepicker-selected');
					} else if (!selected.is(':last-child')) {
						selected.removeClass('ui-timepicker-selected');
						selected.next().addClass('ui-timepicker-selected');
	
						if (selected.next().position().top + 2*selected.outerHeight() > list.outerHeight()) {
							list.scrollTop(list.scrollTop() + selected.outerHeight());
						}
					}
	
					return false;
	
				case 27: // escape
					list.find('li').removeClass('ui-timepicker-selected');
					methods.hide();
					break;
	
				case 9: //tab
					methods.hide();
					break;
	
				default:
					return true;
			}
		}
	
		/*
		*	Time typeahead
		*/
		function _keyuphandler(e)
		{
			var self = $(this);
			var list = self.data('timepicker-list');
			var settings = self.data('timepicker-settings');
	
			if (!list || !_isVisible(list) || settings.disableTextInput) {
				return true;
			}
	
			switch (e.keyCode) {
	
				case 96: // numpad numerals
				case 97:
				case 98:
				case 99:
				case 100:
				case 101:
				case 102:
				case 103:
				case 104:
				case 105:
				case 48: // numerals
				case 49:
				case 50:
				case 51:
				case 52:
				case 53:
				case 54:
				case 55:
				case 56:
				case 57:
				case 65: // a
				case 77: // m
				case 80: // p
				case 186: // colon
				case 8: // backspace
				case 46: // delete
					if (settings.typeaheadHighlight) {
						_setSelected(self, list);
					} else {
						list.hide();
					}
					break;
			}
		}
	
		function _selectValue(self)
		{
			var settings = self.data('timepicker-settings');
			var list = self.data('timepicker-list');
			var timeValue = null;
	
			var cursor = list.find('.ui-timepicker-selected');
	
			if (cursor.hasClass('ui-timepicker-disabled')) {
				return false;
			}
	
			if (cursor.length) {
				// selected value found
				timeValue = cursor.data('time');
			}
	
			if (timeValue !== null) {
				if (typeof timeValue != 'string') {
					timeValue = _int2time(timeValue, settings);
				}
	
				_setTimeValue(self, timeValue, 'select');
			}
	
			return true;
		}
	
		function _int2duration(seconds, step)
		{
			seconds = Math.abs(seconds);
			var minutes = Math.round(seconds/60),
				duration = [],
				hours, mins;
	
			if (minutes < 60) {
				// Only show (x mins) under 1 hour
				duration = [minutes, _lang.mins];
			} else {
				hours = Math.floor(minutes/60);
				mins = minutes%60;
	
				// Show decimal notation (eg: 1.5 hrs) for 30 minute steps
				if (step == 30 && mins == 30) {
					hours += _lang.decimal + 5;
				}
	
				duration.push(hours);
				duration.push(hours == 1 ? _lang.hr : _lang.hrs);
	
				// Show remainder minutes notation (eg: 1 hr 15 mins) for non-30 minute steps
				// and only if there are remainder minutes to show
				if (step != 30 && mins) {
					duration.push(mins);
					duration.push(_lang.mins);
				}
			}
	
			return duration.join(' ');
		}
	
		function _int2time(seconds, settings)
		{
			if (seconds === null) {
				return null;
			}
	
			var time = new Date(_baseDate.valueOf() + (seconds*1000));
	
			if (isNaN(time.getTime())) {
				return null;
			}
	
			if ($.type(settings.timeFormat) === "function") {
				return settings.timeFormat(time);
			}
	
			var output = '';
			var hour, code;
			for (var i=0; i<settings.timeFormat.length; i++) {
	
				code = settings.timeFormat.charAt(i);
				switch (code) {
	
					case 'a':
						output += (time.getHours() > 11) ? _lang.pm : _lang.am;
						break;
	
					case 'A':
						output += (time.getHours() > 11) ? _lang.PM : _lang.AM;
						break;
	
					case 'g':
						hour = time.getHours() % 12;
						output += (hour === 0) ? '12' : hour;
						break;
	
					case 'G':
						hour = time.getHours();
						if (seconds === _ONE_DAY) hour = 24;
						output += hour;
						break;
	
					case 'h':
						hour = time.getHours() % 12;
	
						if (hour !== 0 && hour < 10) {
							hour = '0'+hour;
						}
	
						output += (hour === 0) ? '12' : hour;
						break;
	
					case 'H':
						hour = time.getHours();
						if (seconds === _ONE_DAY) hour = 24;
						output += (hour > 9) ? hour : '0'+hour;
						break;
	
					case 'i':
						var minutes = time.getMinutes();
						output += (minutes > 9) ? minutes : '0'+minutes;
						break;
	
					case 's':
						seconds = time.getSeconds();
						output += (seconds > 9) ? seconds : '0'+seconds;
						break;
	
					case '\\':
						// escape character; add the next character and skip ahead
						i++;
						output += settings.timeFormat.charAt(i);
						break;
	
					default:
						output += code;
				}
			}
	
			return output;
		}
	
		function _time2int(timeString, settings)
		{
			if (timeString === '') return null;
			if (!timeString || timeString+0 == timeString) return timeString;
	
			if (typeof(timeString) == 'object') {
				return timeString.getHours()*3600 + timeString.getMinutes()*60 + timeString.getSeconds();
			}
	
			timeString = timeString.toLowerCase().replace(/[\s\.]/g, '');
	
			// if the last character is an "a" or "p", add the "m"
			if (timeString.slice(-1) == 'a' || timeString.slice(-1) == 'p') {
				timeString += 'm';
			}
	
			var ampmRegex = '(' +
				_lang.am.replace('.', '')+'|' +
				_lang.pm.replace('.', '')+'|' +
				_lang.AM.replace('.', '')+'|' +
				_lang.PM.replace('.', '')+')?';
	
			// try to parse time input
			var pattern = new RegExp('^'+ampmRegex+'([0-2]?[0-9])\\W?([0-5][0-9])?\\W?([0-5][0-9])?'+ampmRegex+'$');
	
			var time = timeString.match(pattern);
			if (!time) {
				return null;
			}
	
			var hour = parseInt(time[2]*1, 10);
			var ampm = time[1] || time[5];
			var hours = hour;
	
			if (hour <= 12 && ampm) {
				var isPm = (ampm == _lang.pm || ampm == _lang.PM);
	
				if (hour == 12) {
					hours = isPm ? 12 : 0;
				} else {
					hours = (hour + (isPm ? 12 : 0));
				}
			}
	
			var minutes = ( time[3]*1 || 0 );
			var seconds = ( time[4]*1 || 0 );
			var timeInt = hours*3600 + minutes*60 + seconds;
	
			// if no am/pm provided, intelligently guess based on the scrollDefault
			if (hour < 12 && !ampm && settings && settings._twelveHourTime && settings.scrollDefault) {
				var delta = timeInt - settings.scrollDefault();
				if (delta < 0 && delta >= _ONE_DAY / -2) {
					timeInt = (timeInt + (_ONE_DAY / 2)) % _ONE_DAY;
				}
			}
	
			return timeInt;
		}
	
		function _pad2(n) {
			return ("0" + n).slice(-2);
		}
	
		// Plugin entry
		$.fn.timepicker = function(method)
		{
			if (!this.length) return this;
			if (methods[method]) {
				// check if this element is a timepicker
				if (!this.hasClass('ui-timepicker-input')) {
					return this;
				}
				return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
			}
			else if(typeof method === "object" || !method) { return methods.init.apply(this, arguments); }
			else { $.error("Method "+ method + " does not exist on jQuery.timepicker"); }
		};
		// Global defaults
		$.fn.timepicker.defaults = {
			className: null,
			minTime: null,
			maxTime: null,
			durationTime: null,
			step: 30,
			showDuration: false,
			showOnFocus: true,
			showOn: ['click', 'focus'],
			timeFormat: 'g:ia',
			scrollDefault: null,
			selectOnBlur: false,
			disableTextInput: false,
			disableTouchKeyboard: false,
			forceRoundTime: false,
			roundingFunction: function(seconds, settings) {
				if (seconds === null) {
					return null;
				} else {
					var offset = seconds % (settings.step*60); // step is in minutes
	
					if (offset >= settings.step*30) {
						// if offset is larger than a half step, round up
						seconds += (settings.step*60) - offset;
					} else {
						// round down
						seconds -= offset;
					}
	
					return seconds;
				}
			},
			appendTo: 'body',
			orientation: 'l',
			disableTimeRanges: [],
			closeOnWindowScroll: false,
			typeaheadHighlight: true,
			noneOption: false,
			show2400: false,
			stopScrollPropagation: false
		};
	}));


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(24))(6);

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	module.exports = slickgrid_lib;

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	'use strict';
	
	var Clubs = window.Clubs = window.Clubs || {};
	
	Clubs.Calendar = {
	  init: function init() {
	    $('td.event_day').hover(function () {
	      $('li.event-row.' + 'date-' + $(this).attr('data-date')).css("background-color", "#F6F6F6");
	    }, function () {
	      $('li.event-row.' + 'date-' + $(this).attr('data-date')).css("background-color", "");
	    });
	    $('.show_details').click(function () {
	      $(this).closest('.event-row').find('.simple_event_details').toggle();
	    });
	
	    $('#simple_event_start_time').timepicker();
	    $('#new-event-container .all_day').on('change', function () {
	      if ($(this).is(':checked')) {
	        $('#simple_event_start_time').hide();
	      } else {
	        $('#simple_event_start_time').show();
	      }
	    });
	
	    $('#event_start_time').timepicker();
	    $('#event_end_time').timepicker();
	    $('#plan-ride-container .all_day').on('change', function () {
	      if ($(this).is(':checked')) {
	        $('#event_start_time').hide();
	        $('#event_end_time').hide();
	      } else {
	        $('#event_start_time').show();
	        $('#event_end_time').show();
	      }
	    });
	
	    $('#plan-ride-container .auto_expire_participants').on('change', function () {
	      if ($(this).is(':checked')) {
	        $('#participant_duration_options').show();
	      } else {
	        $('#participant_duration_options').hide();
	      }
	    });
	
	    $('#club_calendar.can_edit td').on('click', function () {
	      var dateYYMMDD = $(this).attr('data-date');
	      $('.event_start_date').val(dateYYMMDD);
	      rwgps.createEventModal();
	    });
	    $('.plan_simple_event').on('click', function () {
	      $('#new-event-container').on('shown.bs.modal', function () {
	        $('#simple_event_name').focus();
	      });
	    });
	    $('.plan_ride_event').click(function () {
	      $('#plan-ride-container').on('shown.bs.modal', function () {
	        $('body').addClass('modal-open');
	        $('#event_name').focus();
	        $('#event_route_ids').val('');
	      });
	    });
	  },
	  load_month: function load_month(club_id, year, month) {
	    $.get('/clubs/' + club_id + '/calendar', { year: year, month: month }, function (response) {
	      $('#event_calendar').html(response);
	      Clubs.Calendar.init();
	    });
	  }
	};

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClubMembersView = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _filtering_grid_with_bulk_operations = __webpack_require__(9);
	
	var ClubMembersView = exports.ClubMembersView = Backbone.View.extend({
	  el: '#club-members',
	  initialize: function initialize() {
	    var _this = this;
	
	    this.editable = this.options.editable;
	    this.data = this.options.data.map(this.cleanMemberData);
	    this.tags = _.uniq(this.options.data.reduce(this.selectTags, []));
	    this.clubId = this.options.clubId;
	    this.currentMemberId = this.options.baseCurrentMember && this.options.baseCurrentMember.id;
	    this.settings = this.options.settings || {};
	    this.savedSettings = this.settings.saved || {};
	
	    this.initTagInputBoxes();
	    this.initGrid();
	
	    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
	    this.resizeGrid();
	    this.resizeGrid();
	
	    $(window).resize(_.debounce(function () {
	      _this.resizeGrid();
	    }, 100));
	  },
	  events: {
	    // filtering
	    'keyup .filter_by_any': 'filterTextInputChanged',
	    'change .filter_by_permission': 'filtersChanged',
	    'change .filter_by_tag': 'filtersChanged',
	    // bulk operations
	    'click .bulk-op-disabled': 'showDisabledMessage',
	    'click .show_bulk_op': 'showBulkOp',
	    'click .batch_delete': 'batchDelete',
	    'click .batch_make_active': 'batchMakeActive',
	    'click .batch_make_inactive': 'batchMakeInactive',
	    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
	    'click .batch_send_message': 'onBatchMessageClick',
	    // misc
	    'click .grid_height_increase': 'increaseGridHeight',
	    'click .grid_height_decrease': 'decreaseGridHeight',
	    // row-level actions
	    'change .grid_checkbox': 'onCheckboxChange',
	    'click .approve_member': 'onApproveMember'
	  },
	  initGrid: function initGrid() {
	    var _this2 = this;
	
	    var self = this;
	    var data = this.data;
	    var formatters = _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations.formatters;
	
	    var disableableCheckbox = function disableableCheckbox(value, message) {
	      var dataDisabled = message ? 'data-disabled="' + message + '"' : '';
	      var disabledClass = message ? 'bulk-op-disabled' : '';
	      return '<input type="checkbox" ' + (value && 'checked') + ' ' + dataDisabled + ' class="grid_checkbox ' + disabledClass + '">';
	    };
	    var disabledIfAdmin = function disabledIfAdmin(action) {
	      return function (row, cell, value, col, item) {
	        var message = item.admin && 'You cannot ' + action + ' for admins.';
	        return disableableCheckbox(value, message);
	      };
	    };
	    var disabledIfSelfOrAdmin = function disabledIfSelfOrAdmin(action) {
	      return function (row, cell, value, col, item) {
	        var adminMessage = item.admin && 'You cannot ' + action + ' for admins.';
	        var selfMessage = item.id === _this2.currentMemberId && 'You cannot ' + action + ' for yourself.';
	        return disableableCheckbox(value, adminMessage || selfMessage);
	      };
	    };
	    var requiresAdminPriv = function requiresAdminPriv(action) {
	      return function (row, cell, value) {
	        var message = !self.isClubAdmin() && 'You must be an admin to ' + action + '.';
	        return disableableCheckbox(value, message);
	      };
	    };
	    var blankUnlessApprovedMeta = function blankUnlessApprovedMeta(formatter) {
	      return function (row, cell, value, col, item) {
	        return item.approved_at ? formatter(row, cell, value, col, item) : '';
	      };
	    };
	    var approveUnlessApprovedMeta = function approveUnlessApprovedMeta(formatter) {
	      return function (row, cell, value, col, item) {
	        return item.approved_at ? formatter(row, cell, value, col, item) : '<a href="#" class="approve_member">Approve</a>';
	      };
	    };
	
	    // column definitions
	    var columns = [{ id: "first_name", name: 'First name', field: "first_name", sortable: true, editor: Slick.Editors.Text }, { id: "last_name", name: 'Last name', field: "last_name", sortable: true, editor: Slick.Editors.Text }, { id: "display_name", name: 'Display name', field: "display_name", sortable: true }, { id: "email", name: 'Email', field: "email", sortable: true, editor: Slick.Editors.Text }, { id: "tags", name: 'Tags', field: "tags", sortable: true, formatter: formatters.tags }, { id: "admin", name: 'Admin', field: "admin", sortable: true, formatter: blankUnlessApprovedMeta(requiresAdminPriv("set admin privileges")) }, { id: "manages_routes", name: 'Route manager', field: "manages_routes", sortable: true, formatter: blankUnlessApprovedMeta(disabledIfAdmin("set route manager permission")) }, { id: "manages_billing", name: 'Billing manager', field: "manages_billing", sortable: true, formatter: blankUnlessApprovedMeta(disabledIfAdmin("set billing manager permission")) }, { id: "manages_members", name: 'Member manager', field: "manages_members", sortable: true, formatter: blankUnlessApprovedMeta(disabledIfSelfOrAdmin("set member manager permission")) }, { id: "active", name: 'Active', field: "active", sortable: true, formatter: approveUnlessApprovedMeta(disabledIfSelfOrAdmin("set active status")) }, { id: "message", name: '', field: "message", formatter: this.messageFormatter, width: 20 }];
	
	    var columnWidths = Object.assign({
	      message: 20
	    }, this.savedSettings.columnWidths || {});
	    columns.forEach(function (column) {
	      return column.width = columnWidths[column.id];
	    });
	
	    var anyFilter = this.$('.filter_by_any');
	    var permissionFilter = this.$('.filter_by_permission');
	    var tagFilter = this.$('.filter_by_tag');
	    var filterAccessors = new Map(Object.entries({
	      any: anyFilter.val.bind(anyFilter),
	      tag_names: tagFilter.select2.bind(tagFilter, "val"),
	      permission: permissionFilter.val.bind(permissionFilter)
	    }));
	
	    // since approve links show up in the active bool column, need to factor that in while sorting
	    var approvedSortFn = function approvedSortFn(a, b) {
	      return !a.approved_at === !b.approved_at ? 0 : !a.approved_at ? 1 : -1;
	    };
	
	    this.grid = new _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations(data, {
	      target: '#members_table',
	      columns: columns,
	      editable: true,
	      updatePath: function updatePath(id) {
	        return '/clubs/' + _this2.clubId + '/update_member_field.json?club_member_id=' + id;
	      },
	      updateParam: 'club_member',
	      viewPath: function viewPath(item) {
	        return '/users/' + item.user_id;
	      },
	      ignoreCaseOnSort: ['first_name', 'last_name', 'display_name', 'email'],
	      filterAccessors: filterAccessors,
	      settingsOpts: this.settings.opts,
	      stickySortFn: approvedSortFn
	    });
	
	    this.grid.sortingFn('tags', function (a, b) {
	      var x = (a.tag_names || []).join().toUpperCase(),
	          y = (b.tag_names || []).join().toUpperCase();
	      return x == y ? 0 : x > y ? 1 : -1;
	    });
	
	    this.grid.enableFiltering([{ field: 'any', type: 'anyString', extra: ['first_name', 'last_name', 'display_name', 'email'] }, { field: 'first_name', type: 'string' }, { field: 'last_name', type: 'string' }, { field: 'display_name', type: 'string' }, { field: 'tag_names', type: 'arraySubset' }, { field: 'email', type: 'string' }, { field: 'permission', type: 'function', extra: this.filterByPermissionTest }]);
	
	    this.grid.enableBulkOperations({
	      bulkDeletePath: '/clubs/' + this.clubId + '/batch_destroy_members.json',
	      bulkUpdateAttributePath: '/clubs/' + this.clubId + '/batch_set_members_attr.json',
	      idsParam: 'club_member_ids'
	    });
	
	    if (this.savedSettings.sortCol) {
	      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc);
	    } else {
	      this.grid.setSort("email", true);
	    }
	
	    this.grid.slickGrid.onSelectedRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    this.grid.dataView.onRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    self.updateBulkOpVisibility();
	
	    this.initBatchMessageModal();
	  },
	
	  messageFormatter: function messageFormatter(row, cell, value, col, item) {
	    return '<a href="/users/' + rwgps.config.currentUser.id + '/conversations/new?id=' + item.user_id + '" data-toggle="modal" data-target="#sendMessageModal">\n      <i class="icon-envelope-alt"></i>\n    </a>';
	  },
	
	  isClubAdmin: function isClubAdmin() {
	    var _this3 = this;
	
	    if (rwgps.config.currentUser.account_level == 11) {
	      // Site admins can always act as club admins
	      return true;
	    } else if (!this.currentMemberId) {
	      // If the current user is not a member of the club, then they are
	      // definitely not an admin
	      return false;
	    } else {
	      // If we've initialized the grid, use its data, otherwise use the data we
	      // were passed by rails
	      var member = this.grid ? this.grid.dataView.getItemById(this.currentMemberId) : this.data.find(function (item) {
	        return item.id === _this3.currentMemberId;
	      });
	
	      return member && member.admin;
	    }
	  },
	
	  /*
	   * filtering
	   */
	
	  toggleFilters: function toggleFilters() {
	    if (this.$('.toggle_filters .plus').is(':visible')) {
	      this.showFilters();
	    } else {
	      this.hideFilters();
	    }
	  },
	
	  showFilters: function showFilters() {
	    this.$('.toggle_filters').find('.plus').hide().end().find('.minus').show();
	    this.$('.filters').show();
	  },
	
	  hideFilters: function hideFilters() {
	    this.$('.toggle_filters').find('.plus').show().end().find('.minus').hide();
	    this.$('.filters').hide();
	  },
	
	  filterTextInputChanged: function filterTextInputChanged(e) {
	    // clear on escape
	    if (e.which == 27) e.currentTarget.value = '';
	    this.filtersChanged();
	  },
	
	  filtersChanged: function filtersChanged() {
	    if (this.grid) {
	      this.grid.filterInputsChanged();
	    }
	  },
	
	  filterByPermissionTest: function filterByPermissionTest(item, value) {
	    switch (value) {
	      case 'admin':
	      case 'manages_routes':
	      case 'manages_billing':
	      case 'manages_members':
	        return item[value];
	      case 'non_managers':
	        return !(item.manages_routes || item.manages_billing || item.manages_members);
	      default:
	        return true;
	    }
	  },
	
	  /*
	   * editing
	   */
	  onCheckboxChange: function onCheckboxChange(e) {
	    var _this4 = this;
	
	    var _grid$slickGrid$getCe = this.grid.slickGrid.getCellFromEvent(e),
	        row = _grid$slickGrid$getCe.row,
	        cell = _grid$slickGrid$getCe.cell;
	
	    var field = this.grid.slickGrid.getColumns()[cell].field;
	
	    var dataItem = this.grid.slickGrid.getDataItem(row);
	    var club_member_id = dataItem.id;
	
	    var boolValue = e.currentTarget.checked;
	    var value = boolValue ? 1 : 0;
	    var removingOwnAdmin = field === "admin" && club_member_id === this.currentMemberId && !boolValue;
	
	    var updateValue = function updateValue() {
	      // Set set the value immediately, and update or revert it once
	      // we hear back from the server
	      var oldValue = dataItem[field];
	      dataItem[field] = boolValue;
	      _this4.grid.dataView.updateItem(dataItem.id, dataItem);
	
	      _this4.grid.remoteRequest({
	        url: '/clubs/' + _this4.clubId + '/update_member_field.json',
	        params: { club_member_id: club_member_id, field: field, value: value },
	        done: function done(dataView, data) {
	          var memberData = _this4.cleanMemberData(data.club_member);
	          dataView.updateItem(dataItem.id, memberData);
	
	          // Removing one's own admin privs changes the disabled state of
	          // checkboxes outside our own row, so rerender the whole grid
	          if (removingOwnAdmin) {
	            _this4.grid.slickGrid.invalidate();
	          }
	        },
	        fail: function fail() {
	          dataItem[field] = oldValue;
	          _this4.grid.dataView.updateItem(dataItem.id, dataItem);
	          _this4.grid.slickGrid.invalidate();
	        }
	      });
	    };
	
	    if (removingOwnAdmin) {
	      // Reset the checkbox to checked so it's not in the wrong state if the user cancels
	      e.currentTarget.checked = true;
	      customConfirm('Are you sure? By unchecking this option, you will no longer have the ability to assign admin status to organization members.', updateValue);
	    } else {
	      updateValue();
	    }
	  },
	
	  onApproveMember: function onApproveMember(e) {
	    var _this5 = this;
	
	    // TODO: This should use FilteringGridWithBulkOperations.remoteRequest to take advantage of error handling
	    var _grid$slickGrid$getCe2 = this.grid.slickGrid.getCellFromEvent(e),
	        row = _grid$slickGrid$getCe2.row;
	
	    var dataItem = this.grid.slickGrid.getDataItem(row);
	    var club_member_id = dataItem.id;
	
	
	    $.post('/clubs/' + this.clubId + '/approve_member.json', {
	      club_member_id: club_member_id
	    }).done(function (res) {
	      dataItem.approved_at = res.club_member.approved_at;
	      _this5.grid.dataView.updateItem(dataItem.id, dataItem);
	    });
	    return false;
	  },
	
	  /*
	   * bulk operations
	   */
	  updateBulkOpVisibility: function updateBulkOpVisibility() {
	    var _this6 = this;
	
	    var grid = this.grid.slickGrid;
	    var data = grid.getData();
	    var items = grid.getSelectedRows().map(function (i) {
	      return data.getItem(i);
	    });
	
	    var itemsEmpty = items.length == 0;
	    var _adminsSelected = items.some(function (item) {
	      return item.admin;
	    });
	    var notAdmin = !this.isClubAdmin();
	    var _selfSelected = items.some(function (item) {
	      return item.id === _this6.currentMemberId;
	    });
	
	    var disableMessageFuncs = {
	      noneSelected: function noneSelected(action) {
	        return itemsEmpty && 'To ' + action + ', please select at least one member.';
	      },
	      adminsSelected: function adminsSelected(action) {
	        return _adminsSelected && 'You cannot ' + action + ' when admins are selected.';
	      },
	      adminsSelectedNotAdmin: function adminsSelectedNotAdmin(action) {
	        return notAdmin && _adminsSelected && 'You cannot ' + action + ' when admins are selected and you are not an admin.';
	      },
	      selfSelected: function selfSelected(action) {
	        return _selfSelected && 'You cannot ' + action + ' when you are selected.';
	      }
	    };
	
	    var shouldDisable = {
	      tags: { action: "set member tags", disablers: ["noneSelected"] },
	      delete: { action: "delete members", disablers: ["noneSelected", "adminsSelectedNotAdmin"] },
	      make_active: { action: "make members active", disablers: ["noneSelected"] },
	      make_inactive: { action: "make members inactive", disablers: ["noneSelected", "adminsSelected", "selfSelected"] },
	      send_message: { action: "send a message to members", disablers: ["noneSelected"] }
	    };
	
	    var disableMessages = {};
	    Object.entries(shouldDisable).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          op = _ref2[0],
	          info = _ref2[1];
	
	      info.disablers.forEach(function (disabler) {
	        var message = disableMessageFuncs[disabler](info.action);
	        if (message) {
	          disableMessages[op] = message;
	          return;
	        }
	      });
	    });
	
	    this.$("[data-bulk-op]").each(function (idx, el) {
	      var elem = $(el);
	      var op = elem.data("bulk-op");
	      var disableMessage = disableMessages[op];
	
	      if (disableMessage) {
	        elem.addClass("bulk-op-disabled");
	        elem.data("disabled", disableMessage);
	      } else {
	        elem.removeClass("bulk-op-disabled");
	        elem.removeData("disabled");
	        elem.removeAttr("data-disabled");
	      }
	    });
	
	    this.$('.bulk_op').hide();
	  },
	  showDisabledMessage: function showDisabledMessage(e) {
	    var message = $(e.currentTarget).data('disabled');
	    $("#disabled-op-content").html(message);
	    $("#disabled-op").modal("show");
	
	    e.preventDefault();
	    e.stopImmediatePropagation();
	  },
	  showBulkOp: function showBulkOp(e) {
	    var bulkOp = $(e.currentTarget).attr('data-bulk-op');
	    var show = !this.$('.bulk_op_' + bulkOp).is(':visible');
	    this.$('.bulk_op').hide();
	    if (show) this.$('.bulk_op_' + bulkOp).show();
	    return false;
	  },
	  batchDelete: function batchDelete() {
	    var _this7 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No members selected. Click the checkboxes next to the members you'd like to delete first.");
	    } else {
	      customConfirm('Are you sure? This will delete ' + items.length + ' selected member' + (items.length > 1 ? 's' : ''), function () {
	        return _this7.grid.deleteSelectedItems();
	      });
	    }
	    return false;
	  },
	  batchMakeActive: function batchMakeActive() {
	    var _this8 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No members selected. Click the checkboxes next to the members you'd like to make active first.");
	    } else {
	      customConfirm('Are you sure? This will make ' + items.length + ' selected member' + (items.length > 1 ? 's' : '') + ' active', function () {
	        _this8.grid.setAttributeOnSelectedItems('active', true);
	      });
	    }
	    return false;
	  },
	  batchMakeInactive: function batchMakeInactive() {
	    var _this9 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No members selected. Click the checkboxes next to the members you'd like to make active first.");
	    } else {
	      customConfirm('Are you sure? This will make ' + items.length + ' selected member' + (items.length > 1 ? 's' : '') + ' inactive', function () {
	        _this9.grid.setAttributeOnSelectedItems('active', false);
	      });
	    }
	    return false;
	  },
	  batchUpdateTags: function batchUpdateTags(e) {
	    var _this10 = this;
	
	    var tagsStr = this.$('input.tag_names').val();
	    var isAdd = $(e.currentTarget).hasClass('batch_add_tags');
	    var tagAction = isAdd ? 'add' : 'remove';
	
	    if (tagsStr === '') {
	      if (isAdd) customAlert('When adding tags, press &lt;enter&gt; after you type the tag, then click the Add Tags button.');else customAlert('When removing tags, press &lt;enter&gt; after you type the tag, then click the Remove Tags button.');
	      return;
	    }
	
	    this.grid.remoteRequest({
	      url: '/clubs/' + this.clubId + '/batch_update_members_tags.json',
	      params: function params(selectedIds) {
	        return { club_member_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr };
	      },
	      done: function done(dataView, data) {
	        dataView.beginUpdate();
	        data.forEach(function (memberData) {
	          var member = dataView.getItemById(memberData.id);
	          member.tag_names = memberData.tag_names;
	          dataView.updateItem(member.id, member);
	
	          if (isAdd) {
	            member.tag_names.forEach(function (tag) {
	              if (!_this10.tags.includes(tag)) {
	                _this10.tags.push(tag);
	                _this10.$('select.filter_by_tag').append('<option value="' + tag + '">' + tag + '</option>');
	              }
	            });
	          }
	        });
	        dataView.endUpdate();
	        _this10.$('input.tag_names').select2('val', '');
	      }
	    });
	  },
	
	  initBatchMessageModal: function initBatchMessageModal() {
	    var _this11 = this;
	
	    var modal = $("#modal_bulk_message");
	
	    modal.on("click", "button.send-bulk-message", function () {
	      _this11.batchSendMessage();
	    });
	    modal.on('hidden.bs.modal', function () {
	      modal.find(".errors").hide();
	      modal.find(".bulk-message-subject").val("");
	      modal.find(".bulk-message-message").val("");
	    });
	  },
	
	  onBatchMessageClick: function onBatchMessageClick() {
	    var items = this.grid.selectedItems;
	    if (items.length == 0) {
	      return;
	    } else {
	      var members_noun = items.length > 1 ? "members" : "member";
	      $(".bulk-message-title").html('Send message to ' + items.length + ' ' + members_noun);
	      $("#modal_bulk_message").modal("show");
	    }
	    return false;
	  },
	
	  batchSendMessage: function batchSendMessage() {
	    var modal = $("#modal_bulk_message");
	    var errors = modal.find(".errors");
	
	    var subject = modal.find(".bulk-message-subject").val();
	    var message = modal.find(".bulk-message-message").val();
	
	    function showError(message) {
	      errors.html(message);
	      errors.show();
	    }
	
	    if (subject.trim().length === 0 || message.trim().length === 0) {
	      showError("You must enter a subject and a message");
	      return;
	    } else {
	      errors.hide();
	    }
	
	    this.grid.remoteRequest({
	      url: '/clubs/' + this.clubId + '/batch_message_members.json',
	      params: function params(selectedIds) {
	        return { club_member_ids: selectedIds.join(','), subject: subject, message: message };
	      },
	      done: function done() {
	        modal.modal("hide");
	        $.jGrowl("Your message has been sent");
	      },
	      fail: function fail(errors) {
	        showError('Failed to send message: ' + errors.join(', '));
	      },
	      skipFailListeners: true
	    });
	  },
	
	  /*
	   * misc
	   */
	
	  cleanMemberData: function cleanMemberData(data) {
	    return {
	      id: data.id,
	      user_id: data.user_id,
	      first_name: data.first_name || data.user.first_name,
	      last_name: data.last_name || data.user.last_name,
	      display_name: data.user.display_name,
	      email: data.email || data.user.real_email,
	      manages_billing: data.manages_billing,
	      manages_routes: data.manages_routes,
	      manages_members: data.manages_members,
	      admin: data.admin,
	      active: data.active,
	      approved_at: data.approved_at,
	      tag_names: data.tag_names || []
	    };
	  },
	
	  selectTags: function selectTags(accumulator, item) {
	    return accumulator.concat(item.tag_names || []);
	  },
	
	  resizeGrid: function resizeGrid() {
	    // Don't resize anything if sizes have been set by the user
	    if (this.savedSettings.columnWidths) {
	      return;
	    }
	
	    this.grid.slickGrid.resizeCanvas();
	    this.grid.slickGrid.autosizeColumns();
	  },
	  increaseGridHeight: function increaseGridHeight() {
	    this.changeGridHeight(100);
	  },
	  decreaseGridHeight: function decreaseGridHeight() {
	    this.changeGridHeight(-100);
	  },
	  changeGridHeight: function changeGridHeight(amount) {
	    var $table = $('#members_table');
	    var height = $table.height();
	    if (height + amount < 100) return;
	    height += amount;
	    $table.height(height).trigger('resize');
	    Application.setPreference("members_grid_height", height, true);
	  },
	
	
	  initTagInputBoxes: function initTagInputBoxes() {
	    var _this12 = this;
	
	    this.$('.tag_select2_input').val('').select2({
	      openOnEnter: false,
	      width: '150px',
	      placeholder: 'Member Tags',
	      tokenSeparators: [','],
	      tags: this.tags,
	      selectOnBlur: true,
	      formatNoMatches: function formatNoMatches() {
	        return '';
	      },
	      createSearchChoice: function createSearchChoice(term) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this12.tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	
	            if (value.toUpperCase() === term.toUpperCase()) {
	              return { id: value, text: value };
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { id: term, text: term };
	      }
	    });
	  }
	});

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmbedLibraryView = undefined;
	
	var _filtering_grid_with_bulk_operations = __webpack_require__(9);
	
	var EmbedLibraryView = exports.EmbedLibraryView = Backbone.View.extend({
	  el: '#embed-library',
	  initialize: function initialize() {
	    var _this = this;
	
	    this.editable = this.options.editable;
	    this.data = this.options.data;
	    this.clubId = this.options.clubId;
	    this.userDateFormat = this.options.userDateFormat;
	    this.settings = this.options.settings || {};
	    this.savedSettings = this.settings.saved || {};
	
	    this.initGrid();
	
	    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
	    this.resizeGrid();
	    this.resizeGrid();
	
	    $(window).resize(_.debounce(function () {
	      _this.resizeGrid();
	    }, 100));
	  },
	  events: {
	    // bulk operations
	    'click .show_bulk_op': 'showBulkOp',
	    'click .batch_delete': 'batchDelete',
	    // misc
	    'click .grid_height_increase': 'increaseGridHeight',
	    'click .grid_height_decrease': 'decreaseGridHeight'
	  },
	
	  initGrid: function initGrid() {
	    var data = this.data;
	    var formatters = _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations.formatters;
	
	    // column definitions
	    var columns = [{ id: "name", name: 'Name', field: "name", sortable: true }, { id: "date_created", name: 'Date Created', field: "date_created", sortable: true, formatter: formatters.date.bind(this) }, { id: "route_tag", name: 'Route Tag', field: "route_tag", sortable: true }, { id: "poi_tags", name: 'POI Tags', field: "poi_tags", sortable: true, formatter: formatters.genericArray }];
	
	    var columnWidths = Object.assign({
	      icon: 10,
	      edit: 10
	    }, this.savedSettings.columnWidths || {});
	    columns.forEach(function (column) {
	      return column.width = columnWidths[column.id];
	    });
	
	    this.grid = new _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations(data, {
	      target: '#embed_table',
	      columns: columns,
	      editable: this.editable,
	      editPath: function editPath(object) {
	        return '/embeds/configure_regional?id=' + object.id;
	      },
	      ignoreCaseOnSort: ['name', 'route_tag', 'poi_tags'],
	      settingsOpts: this.settings.opts
	    });
	
	    this.grid.enableBulkOperations({
	      bulkDeletePath: '/route_set_overviews/batch_destroy.json',
	      idsParam: 'embed_ids'
	    });
	
	    if (this.savedSettings.sortCol) {
	      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc);
	    }
	
	    var self = this;
	    this.grid.slickGrid.onSelectedRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    this.grid.dataView.onRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    self.updateBulkOpVisibility();
	  },
	
	  /*
	   * bulk operations
	   */
	
	  showBulkOp: function showBulkOp(e) {
	    var bulkOp = $(e.currentTarget).attr('data-bulk-op');
	    var show = !this.$('.bulk_op_' + bulkOp).is(':visible');
	    this.$('.bulk_op').hide();
	    if (show) this.$('.bulk_op_' + bulkOp).show();
	    return false;
	  },
	
	  batchDelete: function batchDelete() {
	    var _this2 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      return; // User message is set in updateBulkOpVisibility
	    } else {
	      var message = 'Are you sure? This will delete ' + items.length + ' selected Embed' + (items.length > 1 ? 's' : '');
	      customConfirm(message, function () {
	        return _this2.grid.deleteSelectedItems();
	      });
	    }
	    return false;
	  },
	
	  updateBulkOpVisibility: function updateBulkOpVisibility() {
	    var grid = this.grid.slickGrid;
	    var data = grid.getData();
	    var items = grid.getSelectedRows().map(function (i) {
	      return data.getItem(i);
	    });
	
	    var noneSelected = items.length == 0 ? "To perform that action, please select at least one embed." : null;
	
	    var shouldDisable = { delete: noneSelected };
	
	    this.$("[data-bulk-op]").each(function (idx, el) {
	      var elem = $(el);
	      var op = elem.data("bulk-op");
	      var disableMessage = shouldDisable[op];
	
	      if (disableMessage) {
	        elem.addClass("bulk-op-disabled");
	        elem.attr("data-disabled", disableMessage);
	      } else {
	        elem.removeClass("bulk-op-disabled");
	        elem.removeAttr("data-disabled");
	      }
	    });
	
	    this.$('.bulk_op').hide();
	  },
	
	  showDisabledMessage: function showDisabledMessage(e) {
	    var message = $(e.currentTarget).data('disabled');
	    $("#disabled-op-content").html(message);
	    $("#disabled-op").modal("show");
	
	    e.stopImmediatePropagation();
	  },
	
	  /*
	   * misc
	   */
	
	  resizeGrid: function resizeGrid() {
	    // Don't resize anything if sizes have been set by the user
	    if (this.savedSettings.columnWidths) {
	      return;
	    }
	
	    this.grid.slickGrid.resizeCanvas();
	    this.grid.slickGrid.autosizeColumns();
	  },
	
	  increaseGridHeight: function increaseGridHeight() {
	    this.changeGridHeight(100);
	  },
	  decreaseGridHeight: function decreaseGridHeight() {
	    this.changeGridHeight(-100);
	  },
	  changeGridHeight: function changeGridHeight(amount) {
	    var $table = $('#embed_table');
	    var height = $table.height();
	    if (height + amount < 100) return;
	    height += amount;
	    $table.height(height).trigger('resize');
	    Application.setPreference("embed_library_grid_height", height, true);
	  }
	});

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventsListView = undefined;
	
	var _filtering_grid_with_bulk_operations = __webpack_require__(9);
	
	var EventsListView = exports.EventsListView = Backbone.View.extend({
	  el: '#event_list',
	  initialize: function initialize() {
	    var _this = this;
	
	    this.editable = this.options.editable;
	    this.data = this.options.data.map(this.cleanEventData);
	    this.tags = _.uniq(this.options.data.reduce(this.selectTags, []));
	    this.userDateFormat = this.options.userDateFormat;
	    this.settings = this.options.settings || {};
	    this.savedSettings = this.settings.saved || {};
	
	    this.initTagInputBoxes();
	    this.initGrid();
	
	    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
	    this.resizeGrid();
	    this.resizeGrid();
	
	    $(window).resize(_.debounce(function () {
	      _this.resizeGrid();
	    }, 100));
	  },
	  events: {
	    // filtering
	    'click .toggle_filters': 'toggleFilters',
	    'keyup .filter_by_name': 'filterTextInputChanged',
	    'keyup .filter_by_location': 'filterTextInputChanged',
	    'change .filter_by_tag': 'filtersChanged',
	    // bulk operations
	    'click .show_bulk_op': 'showBulkOp',
	    'click .batch_set_visibility': 'batchSetVisibility',
	    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
	    'click .batch_delete': 'batchDelete',
	    'click .backup': 'batchBackup',
	    'click .batch_archive': 'batchArchive',
	    'click .batch_unarchive': 'batchUnarchive',
	    // misc
	    'click .grid_height_increase': 'increaseGridHeight',
	    'click .grid_height_decrease': 'decreaseGridHeight'
	  },
	  initGrid: function initGrid() {
	    var events = this.data,
	        formatters = _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations.formatters;
	
	    // column definitions
	    var columns = [{ id: "name", name: T.t('event_name'), field: "name", sortable: true, formatter: formatters.eventName.bind(this), editor: Slick.Editors.Text }, { id: "tags", name: 'Tags', field: "tags", sortable: true, formatter: formatters.tags }, { id: "starts_on", name: 'Starts On', field: "starts_on", sortable: true, formatter: formatters.date.bind(this) }, { id: "created_at", name: 'Created', field: "created_at", sortable: true, formatter: formatters.date.bind(this) }, { id: "num_routes", name: 'Routes', field: "num_routes", sortable: true }, { id: "location", name: T.t('location'), field: "location", sortable: true, editor: Slick.Editors.Text }];
	    if (this.editable) {
	      columns.push({ id: "visibility", name: 'Privacy', field: "visibility", sortable: true, formatter: formatters.visibility, editor: Slick.Editors.YesNoFriendsSelect, isClub: true });
	    }
	
	    var columnWidths = Object.assign({
	      tags: 170,
	      starts_on: 90,
	      created_at: 90,
	      num_routes: 65,
	      location: 125,
	      visibility: 81
	    }, this.savedSettings.columnWidths || {});
	    columns.forEach(function (column) {
	      return column.width = columnWidths[column.id];
	    });
	
	    var nameFilter = this.$('.filter_by_name');
	    var tagFilter = this.$('.filter_by_tag');
	    var locationFilter = this.$('.filter_by_location');
	    var filterAccessors = new Map(Object.entries({
	      name: nameFilter.val.bind(nameFilter),
	      tag_names: tagFilter.select2.bind(tagFilter, "val"),
	      location: locationFilter.val.bind(locationFilter)
	    }));
	
	    this.grid = new _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations(events, {
	      target: '#events_table',
	      columns: columns,
	      editable: this.editable,
	      updatePath: function updatePath(id) {
	        return '/events/' + id + '/simple_update.json';
	      },
	      updateParam: 'event',
	      viewPath: function viewPath(item) {
	        return '/events/' + item.slug;
	      },
	      ignoreCaseOnSort: ['name', 'location'],
	      filterAccessors: filterAccessors,
	      settingsOpts: this.settings.opts
	    });
	
	    // case insensitive sort of concatenated tags
	    this.grid.sortingFn('tags', function (a, b) {
	      var x = (a.tag_names || []).join().toUpperCase(),
	          y = (b.tag_names || []).join().toUpperCase();
	      return x == y ? 0 : x > y ? 1 : -1;
	    });
	
	    var params = rwgps.Utils.getQueryParameters(window.location.search);
	    var viewingArchives = params.archive === 'true';
	
	    this.grid.enableFiltering([{ field: 'name', type: 'string' }, { field: 'tag_names', type: 'arraySubset' }, { field: 'location', type: 'string' }, { field: 'archived_at', type: 'function', extra: this.getFilterByViewingArchives(viewingArchives) }]);
	
	    this.grid.enableBulkOperations({
	      bulkUpdateAttributePath: '/events/batch_set_attr.json',
	      bulkDeletePath: '/events/batch_destroy.json',
	      idsParam: 'event_ids'
	    });
	
	    if (this.savedSettings.sortCol) {
	      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc);
	    }
	  },
	
	  /*
	   * filtering
	   */
	
	  toggleFilters: function toggleFilters() {
	    if (this.$('.toggle_filters .plus').is(':visible')) {
	      this.showFilters();
	    } else {
	      this.hideFilters();
	    }
	  },
	
	  showFilters: function showFilters() {
	    this.$('.toggle_filters').find('.plus').hide().end().find('.minus').show();
	    this.$('.filters').show();
	  },
	
	  hideFilters: function hideFilters() {
	    this.$('.toggle_filters').find('.plus').show().end().find('.minus').hide();
	    this.$('.filters').hide();
	  },
	
	  filterTextInputChanged: function filterTextInputChanged(e) {
	    // clear on escape
	    if (e.which == 27) e.currentTarget.value = '';
	    this.filtersChanged();
	  },
	
	  filtersChanged: function filtersChanged() {
	    if (this.grid) {
	      this.grid.filterInputsChanged();
	    }
	  },
	
	  getFilterByViewingArchives: function getFilterByViewingArchives(viewingArchives) {
	    return function (item) {
	      if (viewingArchives) {
	        return !!item.archived_at;
	      }
	      if (!viewingArchives) {
	        return !item.archived_at;
	      }
	    };
	  },
	
	  /*
	   * bulk operations
	   */
	
	  showBulkOp: function showBulkOp(e) {
	    var bulkOp = $(e.currentTarget).attr('data-bulk-op');
	    this.$('.bulk_op_' + bulkOp).toggle();
	    return false;
	  },
	
	  batchSetVisibility: function batchSetVisibility() {
	    var visVal = parseInt(this.$('select.visibility').val());
	    this.grid.setAttributeOnSelectedItems('visibility', visVal);
	  },
	
	  batchArchive: function batchArchive() {
	    var _this2 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No routes selected. Click the checkboxes next to the events you'd like to archive first.");
	    } else {
	      customConfirm('Are you sure? This will archive ' + items.length + ' selected event' + (items.length === 1 ? '' : 's'), function () {
	        return _this2.grid.setAttributeOnSelectedItems('archived_at', new Date()).always(function () {
	          _this2.grid.setSelectedRows([]);
	          _this2.filtersChanged();
	        });
	      });
	    }
	    return false;
	  },
	
	  batchUnarchive: function batchUnarchive() {
	    var _this3 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No routes selected. Click the checkboxes next to the events you'd like to unarchive first.");
	    } else {
	      customConfirm('Are you sure? This will unarchive ' + items.length + ' selected event' + (items.length === 1 ? '' : 's'), function () {
	        return _this3.grid.setAttributeOnSelectedItems('archived_at', null).always(function () {
	          _this3.grid.setSelectedRows([]);
	          _this3.filtersChanged();
	        });
	      });
	    }
	    return false;
	  },
	
	  initTagInputBoxes: function initTagInputBoxes() {
	    var _this4 = this;
	
	    this.$('.tag_select2_input').val('').select2({
	      openOnEnter: false,
	      width: '150px',
	      placeholder: 'Event Tags',
	      tokenSeparators: [','],
	      tags: this.tags,
	      selectOnBlur: true,
	      formatNoMatches: function formatNoMatches() {
	        return '';
	      },
	      createSearchChoice: function createSearchChoice(term) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this4.tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	
	            if (value.toUpperCase() === term.toUpperCase()) {
	              return { id: value, text: value };
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { id: term, text: term };
	      }
	    });
	  },
	
	  batchDelete: function batchDelete() {
	    var _this5 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No events selected. Click the checkboxes next to the events you'd like to delete first.");
	    } else {
	      customConfirm('Are you sure? This will delete ' + items.length + ' selected event' + (items.length === 1 ? '' : 's'), function () {
	        return _this5.grid.deleteSelectedItems();
	      });
	    }
	    return false;
	  },
	
	  batchBackup: function batchBackup() {
	    var items = this.grid.selectedItems;
	    if (!items.length) return false;
	
	    customConfirm("Create a backup of the selected " + (items.length > 1 ? items.length + " events" : "event") + "?", function () {
	      var ids = _.map(items, function (_ref) {
	        var id = _ref.id;
	        return id;
	      });
	      $.post('/user_backups', { user_backup: { format: 'json', content: { events: ids } } }, function (resp) {
	        customAlert(resp.message);
	      });
	    });
	    return false;
	  },
	
	  batchUpdateTags: function batchUpdateTags(e) {
	    var _this6 = this;
	
	    var tagsStr = this.$('input.tag_names').val();
	    var isAdd = $(e.currentTarget).hasClass('batch_add_tags');
	    var tagAction = isAdd ? 'add' : 'remove';
	
	    if (tagsStr === '') {
	      if (isAdd) customAlert('When adding tags, press &lt;enter&gt; after you type the tag, then click the Add Tags button.');else customAlert('When removing tags, press &lt;enter&gt; after you type the tag, then click the Remove Tags button.');
	      return;
	    }
	
	    this.grid.remoteRequest({
	      url: '/events/batch_update_tags.json',
	      params: function params(selectedIds) {
	        return { event_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr };
	      },
	      done: function done(dataView, data) {
	        dataView.beginUpdate();
	        data.events.forEach(function (eventData) {
	          var event = dataView.getItemById(eventData.id);
	          event.tag_names = eventData.tag_names;
	          dataView.updateItem(event.id, event);
	
	          if (isAdd) {
	            event.tag_names.forEach(function (tag) {
	              if (!_this6.tags.includes(tag)) {
	                _this6.tags.push(tag);
	                _this6.$('select.filter_by_tag').append('<option value="' + tag + '">' + tag + '</option>');
	              }
	            });
	          }
	        });
	        dataView.endUpdate();
	        _this6.$('input.tag_names').select2('val', '');
	      }
	    });
	  },
	
	  cleanEventData: function cleanEventData(data) {
	    var event = Object.assign(data);
	    event.created_at = rwgps.DateExt.parse(event.created_at);
	    event.updated_at = rwgps.DateExt.parse(event.updated_at);
	    return event;
	  },
	
	  /*
	   * misc
	   */
	
	  selectTags: function selectTags(accumulator, item) {
	    return accumulator.concat(item.tag_names || []);
	  },
	  resizeGrid: function resizeGrid() {
	    // Don't resize anything if sizes have been set by the user
	    if (this.savedSettings.columnWidths) {
	      return;
	    }
	
	    var size = 0;
	    var nameItem = void 0;
	    _.each(this.grid.slickGrid.getColumns(), function (item) {
	      if (item.id == "name") nameItem = item;else size += item.width;
	    });
	    nameItem.width = this.grid.slickGrid.getViewport().rightPx - size;
	    this.grid.slickGrid.resizeCanvas();
	    this.grid.slickGrid.autosizeColumns();
	  },
	  increaseGridHeight: function increaseGridHeight() {
	    this.changeGridHeight(100);
	  },
	  decreaseGridHeight: function decreaseGridHeight() {
	    this.changeGridHeight(-100);
	  },
	  changeGridHeight: function changeGridHeight(amount) {
	    var $table = $('#events_table');
	    var height = $table.height();
	    if (height + amount < 100) return;
	    height += amount;
	    $table.height(height).trigger('resize');
	    Application.setPreference("events_grid_height", height, true);
	  }
	});

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExperiencesView = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _filtering_grid_with_bulk_operations = __webpack_require__(9);
	
	var ExperiencesView = exports.ExperiencesView = Backbone.View.extend({
	  el: '#experiences',
	  initialize: function initialize() {
	    var _this = this;
	
	    this.editable = this.options.editable;
	    this.data = this.options.data;
	    this.tags = _.uniq(this.options.data.reduce(this.selectTags, []));
	    this.clubId = this.options.clubId;
	    this.userDateFormat = this.options.userDateFormat;
	    this.settings = this.options.settings || {};
	    this.savedSettings = this.settings.saved || {};
	
	    var params = rwgps.Utils.getQueryParameters(window.location.search);
	    var viewingArchives = params.archive === 'true';
	    this.$el.toggleClass('showingArchives', viewingArchives);
	    this.$el.toggleClass('showingLibrary', !viewingArchives);
	
	    this.initTagInputBoxes();
	    this.initGrid();
	
	    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
	    this.resizeGrid();
	    this.resizeGrid();
	
	    $(window).resize(_.debounce(function () {
	      _this.resizeGrid();
	    }, 100));
	  },
	  events: {
	    // filtering
	    'keyup .filter_by_any': 'filterTextInputChanged',
	    'change .filter_by_tag': 'filtersChanged',
	    'change .filter_by_publish_status': 'filtersChanged',
	    // bulk operations
	    'click .bulk-op-disabled': 'showDisabledMessage',
	    'click .show_bulk_op': 'showBulkOp',
	    'click .batch_delete': 'batchDelete',
	    'click .batch_make_active': 'batchMakeActive',
	    'click .batch_make_inactive': 'batchMakeInactive',
	    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
	    'click .batch_archive': 'batchArchive',
	    'click .batch_unarchive': 'batchUnarchive',
	    // misc
	    'click .grid_height_increase': 'increaseGridHeight',
	    'click .grid_height_decrease': 'decreaseGridHeight',
	
	    'mousedown .route-info': 'experienceAudits'
	  },
	
	  initGrid: function initGrid() {
	    var data = this.data;
	    var formatters = _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations.formatters;
	
	    // column definitions
	    var columns = [{ id: "name", name: 'Name', field: "name", sortable: true, formatter: formatters.eventName.bind(this), editor: Slick.Editors.Text }, { id: "reference_id", name: 'Reference ID', field: "reference_id", sortable: true }, { id: "tags", name: 'Tags', field: "tags", sortable: true, formatter: formatters.tags }, { id: "starts_on", name: 'Starts On', field: "starts_on", sortable: true, formatter: formatters.date.bind(this) }, { id: "created_at", name: 'Created', field: "created_at", sortable: true, formatter: formatters.date.bind(this) }, { id: "routes_count", name: 'Routes', field: "routes_count", sortable: true }, { id: "publish_status", name: 'Publish Status', field: "publish_status", sortable: true, formatter: formatters.capitalize.bind(this) }, { id: "info", name: '', field: "info", formatter: formatters.info, resizable: false }];
	
	    var columnWidths = Object.assign({
	      info: 45,
	      edit: 10
	    }, this.savedSettings.columnWidths || {});
	    columns.forEach(function (column) {
	      return column.width = columnWidths[column.id];
	    });
	
	    var anyFilter = this.$('.filter_by_any');
	    var tagFilter = this.$('.filter_by_tag');
	    var publishStatusFilter = this.$('.filter_by_publish_status');
	    var filterAccessors = new Map(Object.entries({
	      any: anyFilter.val.bind(anyFilter),
	      publish_status: publishStatusFilter.val.bind(publishStatusFilter),
	      tag_names: tagFilter.select2.bind(tagFilter, "val")
	    }));
	
	    this.grid = new _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations(data, {
	      target: '#experiences_table',
	      columns: columns,
	      editable: this.editable,
	      editPath: function editPath(object) {
	        return '/experiences/' + object.id + '/edit';
	      },
	      updatePath: function updatePath(id) {
	        return '/experiences/' + id + '.json';
	      },
	      updateParam: 'experience',
	      ignoreCaseOnSort: ['name', 'reference_id'],
	      filterAccessors: filterAccessors,
	      settingsOpts: this.settings.opts
	    });
	
	    this.grid.sortingFn('tags', function (a, b) {
	      var x = (a.tag_names || []).join().toUpperCase(),
	          y = (b.tag_names || []).join().toUpperCase();
	      return x == y ? 0 : x > y ? 1 : -1;
	    });
	
	    var params = rwgps.Utils.getQueryParameters(window.location.search);
	    var viewingArchives = params.archive === 'true';
	
	    this.grid.enableFiltering([{ field: 'any', type: 'anyString', extra: ['name', 'reference_id'] }, { field: 'tag_names', type: 'arraySubset' }, { field: 'publish_status', type: 'array' }, { field: 'archived_at', type: 'function', extra: this.getFilterByViewingArchives(viewingArchives) }]);
	
	    this.grid.enableBulkOperations({
	      bulkDeletePath: '/experiences/batch_destroy.json',
	      bulkUpdateAttributePath: '/clubs/' + this.clubId + '/batch_set_experiences_attr.json',
	      idsParam: 'experience_ids'
	    });
	
	    if (this.savedSettings.sortCol) {
	      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc);
	    }
	
	    var self = this;
	    this.grid.slickGrid.onSelectedRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    this.grid.dataView.onRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    self.updateBulkOpVisibility();
	
	    // As it turns out, we need to have this here so any data stuff that happens before filters
	    // get changed will receive a copy of the current filters values.
	    // The routes_view.js gets around this, because makeSlider() triggers this call as a side-effect.
	    this.grid.filterInputsChanged();
	  },
	
	  /*
	   * filtering
	   */
	
	  filterTextInputChanged: function filterTextInputChanged(e) {
	    // clear on escape
	    if (e.which == 27) e.currentTarget.value = '';
	    this.filtersChanged();
	  },
	
	  filtersChanged: function filtersChanged() {
	    if (this.grid) {
	      this.grid.filterInputsChanged();
	    }
	  },
	
	  /*
	   * bulk operations
	   */
	
	  showDisabledMessage: function showDisabledMessage(e) {
	    var message = $(e.currentTarget).data('disabled');
	    $("#disabled-op-content").html(message);
	    $("#disabled-op").modal("show");
	
	    e.preventDefault();
	    e.stopImmediatePropagation();
	  },
	
	  showBulkOp: function showBulkOp(e) {
	    var bulkOp = $(e.currentTarget).attr('data-bulk-op');
	    var show = !this.$('.bulk_op_' + bulkOp).is(':visible');
	    this.$('.bulk_op').hide();
	    if (show) this.$('.bulk_op_' + bulkOp).show();
	    return false;
	  },
	
	  batchDelete: function batchDelete() {
	    var _this2 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      return;
	    } else {
	      var message = 'Are you sure? This will delete ' + items.length + ' selected Experience' + (items.length > 1 ? 's' : '');
	      customConfirm(message, function () {
	        return _this2.grid.deleteSelectedItems();
	      });
	    }
	    return false;
	  },
	
	  batchMakeActive: function batchMakeActive() {
	    var _this3 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No experiences selected. Click the checkboxes next to the experiences you'd like to enable first.");
	    } else {
	      customConfirm('Are you sure? This will enable ' + items.length + ' selected experience' + (items.length > 1 ? 's' : ''), function () {
	        _this3.grid.setAttributeOnSelectedItems('active', true, function (item) {
	          item.publish_status = 'queued';
	        });
	      });
	    }
	    return false;
	  },
	
	  batchMakeInactive: function batchMakeInactive() {
	    var _this4 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No experiences selected. Click the checkboxes next to the experiences you'd like to disable first.");
	    } else {
	      customConfirm('Are you sure? This will disable ' + items.length + ' selected experience' + (items.length > 1 ? 's' : ''), function () {
	        _this4.grid.setAttributeOnSelectedItems('active', false, function (item) {
	          item.publish_status = 'unpublished';
	        });
	      });
	    }
	    return false;
	  },
	
	  batchArchive: function batchArchive() {
	    var _this5 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No routes selected. Click the checkboxes next to the experiences you'd like to archive first.");
	    } else {
	      customConfirm('Are you sure? This will archive ' + items.length + ' selected experience' + (items.length === 1 ? '' : 's'), function () {
	        return _this5.grid.setAttributeOnSelectedItems('archived_at', new Date()).always(function () {
	          _this5.grid.setSelectedRows([]);
	          _this5.filtersChanged();
	        });
	      });
	    }
	    return false;
	  },
	
	  batchUnarchive: function batchUnarchive() {
	    var _this6 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert("No routes selected. Click the checkboxes next to the experiences you'd like to unarchive first.");
	    } else {
	      customConfirm('Are you sure? This will unarchive ' + items.length + ' selected experience' + (items.length === 1 ? '' : 's'), function () {
	        return _this6.grid.setAttributeOnSelectedItems('archived_at', null).always(function () {
	          _this6.grid.setSelectedRows([]);
	          _this6.filtersChanged();
	        });
	      });
	    }
	    return false;
	  },
	
	  batchUpdateTags: function batchUpdateTags(e) {
	    var _this7 = this;
	
	    var tagsStr = this.$('input.tag_names').val();
	    var isAdd = $(e.currentTarget).hasClass('batch_add_tags');
	    var tagAction = isAdd ? 'add' : 'remove';
	
	    if (tagsStr === '') {
	      if (isAdd) customAlert('When adding tags, press &lt;enter&gt; after you type the tag, then click the Add Tags button.');else customAlert('When removing tags, press &lt;enter&gt; after you type the tag, then click the Remove Tags button.');
	      return;
	    }
	
	    this.grid.remoteRequest({
	      url: '/clubs/' + this.clubId + '/batch_update_experiences_tags.json',
	      params: function params(selectedIds) {
	        return { experience_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr };
	      },
	      done: function done(dataView, data) {
	        dataView.beginUpdate();
	        data.forEach(function (memberData) {
	          var member = dataView.getItemById(memberData.id);
	          member.tag_names = memberData.tag_names;
	          dataView.updateItem(member.id, member);
	
	          if (isAdd) {
	            member.tag_names.forEach(function (tag) {
	              if (!_this7.tags.includes(tag)) {
	                _this7.tags.push(tag);
	                _this7.$('select.filter_by_tag').append('<option value="' + tag + '">' + tag + '</option>');
	              }
	            });
	          }
	        });
	        dataView.endUpdate();
	        _this7.$('input.tag_names').select2('val', '');
	      }
	    });
	  },
	
	  updateBulkOpVisibility: function updateBulkOpVisibility() {
	    var grid = this.grid.slickGrid;
	    var data = grid.getData();
	    var items = grid.getSelectedRows().map(function (i) {
	      return data.getItem(i);
	    });
	
	    var itemsEmpty = items.length == 0;
	
	    var disableMessageFuncs = {
	      noneSelected: function noneSelected(action) {
	        return itemsEmpty && 'To ' + action + ', please select at least one experience.';
	      }
	    };
	
	    var shouldDisable = {
	      tags: { action: "set tags", disablers: ["noneSelected"] },
	      make_active: { action: "enable", disablers: ["noneSelected"] },
	      make_inactive: { action: "disable", disablers: ["noneSelected"] },
	      delete: { action: "delete members", disablers: ["noneSelected"] },
	      archive: { action: "enable", disablers: ["noneSelected"] },
	      unarchive: { action: "enable", disablers: ["noneSelected"] }
	    };
	
	    var disableMessages = {};
	    Object.entries(shouldDisable).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          op = _ref2[0],
	          info = _ref2[1];
	
	      info.disablers.forEach(function (disabler) {
	        var message = disableMessageFuncs[disabler](info.action);
	        if (message) {
	          disableMessages[op] = message;
	          return;
	        }
	      });
	    });
	
	    this.$("[data-bulk-op]").each(function (idx, el) {
	      var elem = $(el);
	      var op = elem.data("bulk-op");
	      var disableMessage = disableMessages[op];
	
	      if (disableMessage) {
	        elem.addClass("bulk-op-disabled");
	        elem.data("disabled", disableMessage);
	      } else {
	        elem.removeClass("bulk-op-disabled");
	        elem.removeData("disabled");
	        elem.removeAttr("data-disabled");
	      }
	    });
	
	    this.$('.bulk_op').hide();
	  },
	
	  getFilterByViewingArchives: function getFilterByViewingArchives(viewingArchives) {
	    return function (item) {
	      if (viewingArchives) {
	        return !!item.archived_at;
	      }
	      if (!viewingArchives) {
	        return !item.archived_at;
	      }
	    };
	  },
	
	  /*
	   * misc
	   */
	
	  resizeGrid: function resizeGrid() {
	    // Don't resize anything if sizes have been set by the user
	    if (this.savedSettings.columnWidths) {
	      return;
	    }
	
	    this.grid.slickGrid.resizeCanvas();
	    this.grid.slickGrid.autosizeColumns();
	  },
	
	  selectTags: function selectTags(accumulator, item) {
	    return accumulator.concat(item.tag_names || []);
	  },
	
	  increaseGridHeight: function increaseGridHeight() {
	    this.changeGridHeight(100);
	  },
	  decreaseGridHeight: function decreaseGridHeight() {
	    this.changeGridHeight(-100);
	  },
	  experienceAudits: function experienceAudits(e) {
	    var experienceId = $(e.currentTarget).data('id');
	    $.get("/experiences/" + experienceId + "/audits", function (resp) {
	      $('#experiences-info-modal').html(resp).modal();
	    });
	  },
	  changeGridHeight: function changeGridHeight(amount) {
	    var $table = $('#experiences_table');
	    var height = $table.height();
	    if (height + amount < 100) return;
	    height += amount;
	    $table.height(height).trigger('resize');
	    Application.setPreference("experiences_grid_height", height, true);
	  },
	
	  initTagInputBoxes: function initTagInputBoxes() {
	    var _this8 = this;
	
	    this.$('.tag_select2_input').val('').select2({
	      openOnEnter: false,
	      width: '150px',
	      placeholder: 'Experience Tags',
	      tokenSeparators: [','],
	      tags: this.tags,
	      selectOnBlur: true,
	      formatNoMatches: function formatNoMatches() {
	        return '';
	      },
	      createSearchChoice: function createSearchChoice(term) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this8.tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	
	            if (value.toUpperCase() === term.toUpperCase()) {
	              return { id: value, text: value };
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { id: term, text: term };
	      }
	    });
	  }
	});

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PoiLibraryView = undefined;
	
	var _filtering_grid_with_bulk_operations = __webpack_require__(9);
	
	var PoiLibraryView = exports.PoiLibraryView = Backbone.View.extend({
	  el: '#poi-library',
	  initialize: function initialize() {
	    var _this = this;
	
	    this.editable = this.options.editable;
	    this.data = this.options.data;
	    this.poiIcons = this.options.poiIcons;
	    this.clubId = this.options.clubId;
	    this.tags = this.options.tags;
	    this.settings = this.options.settings || {};
	    this.savedSettings = this.settings.saved || {};
	
	    this.initTagInputBoxes();
	    this.initRouteSearchBox();
	    this.initGrid();
	
	    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
	    this.resizeGrid();
	    this.resizeGrid();
	
	    $(window).resize(_.debounce(function () {
	      _this.resizeGrid();
	    }, 100));
	  },
	  events: {
	    // filtering
	    'click [data-disabled]': 'showDisabledMessage',
	    'keyup .filter_by_name': 'filtersChanged',
	    'keyup .filter_by_description': 'filtersChanged',
	    'change .filter_by_tag': 'filtersChanged',
	    // bulk operations
	    'click .show_bulk_op': 'showBulkOp',
	    'click .batch_delete': 'batchDelete',
	    'click .combine_poi': 'combine',
	    'click .batch_tags': 'batchChangeTags',
	    'click .batch_add_routes,.batch_remove_routes': 'onBatchRoutesClick',
	    'click .associate_routes': 'associateRoutes',
	    'click .poi-edit-button': 'onPoiEditClick',
	    'click .new-poi-link': 'onPoiEditClick',
	    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
	    'click .CTA.associate-routes': 'associateRoutes',
	    // misc
	    'click .grid_height_increase': 'increaseGridHeight',
	    'click .grid_height_decrease': 'decreaseGridHeight'
	  },
	
	  initGrid: function initGrid() {
	    var _this2 = this;
	
	    var data = this.data;
	    var formatters = _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations.formatters;
	
	    var formatPoiIcon = function formatPoiIcon(row, cell, value, col, item) {
	      var iconData = item && _.findWhere(_this2.poiIcons, { 'name': item.poi_type_name });
	      var filename = iconData && iconData.icon || "generic.png";
	      var icon = '/images/poi_icons/' + filename + '?2';
	      return '<img src="' + icon + '" style="max-height: 100%" />';
	    };
	
	    var formatPoiEdit = function formatPoiEdit(row, cell, value, col, item) {
	      return '<a href="javascript:;" class="poi-edit-button" style="color:#f80;"><span class="icon icon-edit" style="font-size:16px" data-id="' + item.id + '"></span></a>';
	    };
	
	    // column definitions
	    var columns = [{ id: "icon", name: 'Icon', field: "icon", sortable: true, formatter: formatPoiIcon }, { id: "name", name: 'Name', field: "name", sortable: true, editor: Slick.Editors.Text }, { id: "tag_names", name: 'Tags', field: "tag_names", sortable: true, formatter: formatters.tags }, { id: "description", name: 'Description', field: "description", sortable: true, editor: Slick.Editors.Text }, { id: "url", name: 'URL', field: "url", sortable: true, editor: Slick.Editors.Text }];
	    if (this.editable) {
	      columns.push({ id: "edit", name: '', field: "edit", formatter: formatPoiEdit });
	    }
	
	    var columnWidths = Object.assign({
	      icon: 10,
	      edit: 10
	    }, this.savedSettings.columnWidths || {});
	    columns.forEach(function (column) {
	      return column.width = columnWidths[column.id];
	    });
	
	    var nameFilter = this.$('.filter_by_name');
	    var descriptionFilter = this.$('.filter_by_description');
	    var tagFilter = this.$('.filter_by_tag');
	    var filterAccessors = new Map(Object.entries({
	      name: nameFilter.val.bind(nameFilter),
	      description: nameFilter.val.bind(descriptionFilter),
	      tag_names: tagFilter.select2.bind(tagFilter, "val")
	    }));
	
	    var baseUrl = '/clubs/' + this.clubId + '/points_of_interest';
	
	    this.grid = new _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations(data, {
	      target: '#poi_table',
	      columns: columns,
	      editable: this.editable,
	      updatePath: function updatePath(id) {
	        return baseUrl + '/' + id + '.json';
	      },
	      updateParam: 'point_of_interest',
	      ignoreCaseOnSort: ['name', 'location', 'url'],
	      filterAccessors: filterAccessors,
	      settingsOpts: this.settings.opts
	    });
	
	    this.grid.enableFiltering([{ field: 'name', type: 'string' }, { field: 'tag_names', type: 'arraySubset' }, { field: 'description', type: 'string' }]);
	
	    this.grid.enableBulkOperations({
	      bulkDeletePath: baseUrl + '/batch_destroy.json',
	      idsParam: 'poi_ids'
	    });
	
	    if (this.savedSettings.sortCol) {
	      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc);
	    }
	
	    var self = this;
	    this.grid.slickGrid.onSelectedRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    this.grid.dataView.onRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    self.updateBulkOpVisibility();
	  },
	
	  /*
	   * filtering
	   */
	
	  toggleFilters: function toggleFilters() {
	    if (this.$('.toggle_filters .plus').is(':visible')) {
	      this.showFilters();
	    } else {
	      this.hideFilters();
	    }
	  },
	
	  showFilters: function showFilters() {
	    this.$('.toggle_filters').find('.plus').hide().end().find('.minus').show();
	    this.$('.filters').show();
	  },
	
	  hideFilters: function hideFilters() {
	    this.$('.toggle_filters').find('.plus').show().end().find('.minus').hide();
	    this.$('.filters').hide();
	  },
	
	  filterTextInputChanged: function filterTextInputChanged(e) {
	    // clear on escape
	    if (e.which == 27) e.currentTarget.value = '';
	    this.filtersChanged();
	  },
	
	  filtersChanged: function filtersChanged() {
	    if (this.grid) {
	      this.grid.filterInputsChanged();
	    }
	  },
	
	  onPoiEditClick: function onPoiEditClick(e) {
	    var _this3 = this;
	
	    var poiId = e.target.dataset["id"];
	    rwgps.clubPoiEditor({
	      poiId: poiId,
	      clubId: this.clubId,
	      onEditSuccess: function onEditSuccess(data) {
	        return _this3.onPoiEditSuccess(data);
	      },
	      tags: this.tags
	    });
	  },
	
	  onPoiEditSuccess: function onPoiEditSuccess(data) {
	    var editedPoi = data.point_of_interest;
	    // optional ids of POIs that have been combined into editedPoi
	    var combinedPoiIds = data.combined_ids || [];
	    var dataView = this.grid.dataView;
	
	    dataView.beginUpdate();
	    if (dataView.getItemById(editedPoi.id)) {
	      dataView.updateItem(editedPoi.id, editedPoi);
	      combinedPoiIds.forEach(function (poiId) {
	        if (poiId !== editedPoi.id) {
	          dataView.deleteItem(poiId);
	        }
	      });
	    } else {
	      dataView.insertItem(0, editedPoi);
	    }
	    this.grid.setSelectedRows([]);
	    dataView.reSort();
	    dataView.endUpdate();
	  },
	
	  /*
	   * bulk operations
	   */
	
	  showBulkOp: function showBulkOp(e) {
	    var bulkOp = $(e.currentTarget).attr('data-bulk-op');
	    var show = !this.$('.bulk_op_' + bulkOp).is(':visible');
	    this.$('.bulk_op').hide();
	    if (show) this.$('.bulk_op_' + bulkOp).show();
	    return false;
	  },
	
	  initTagInputBoxes: function initTagInputBoxes() {
	    var _this4 = this;
	
	    this.$('.tag_select2_input').val('').select2({
	      openOnEnter: false,
	      width: '180px',
	      placeholder: 'POI Tags',
	      tokenSeparators: [','],
	      tags: this.tags,
	      selectOnBlur: true,
	      formatNoMatches: function formatNoMatches() {
	        return "";
	      },
	      createSearchChoice: function createSearchChoice(term) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this4.tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	
	            if (value.toUpperCase() === term.toUpperCase()) {
	              return { id: value, text: value };
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { id: term, text: term };
	      }
	    });
	  },
	
	  initRouteSearchBox: function initRouteSearchBox() {
	    var routesButton = $('.CTA.associate-routes');
	    var searchBox = $("#route_search_box");
	
	    var updateButtonVisibility = function updateButtonVisibility() {
	      var routes = searchBox.select2('val');
	      if (routes.length > 0) {
	        routesButton.removeClass('disabled');
	        routesButton.removeAttr('data-disabled');
	      } else {
	        routesButton.addClass('disabled');
	        routesButton.attr('data-disabled', 'Use the field to search for one or more routes');
	      }
	    };
	
	    searchBox.select2({
	      width: 'resolve', //try style, fallback to JS to detect proper width
	      //placeholder: "Select one or more routes",
	      minimumInputLength: 3,
	      multiple: true,
	      ajax: {
	        url: "/find/search.json",
	        dataType: "json",
	        data: function data(term) {
	          return {
	            'search[user_id]': (rwgps.config.currentUser || {}).id,
	            'search[routes]': 'true',
	            'search[sort_by]': 'rank',
	            'search[exclude_trips]': 'true',
	            'search[keywords]': term
	          };
	        },
	        results: function results(data) {
	          return {
	            results: _.map(data.results, function (res) {
	              return res[res.type];
	            })
	          };
	        }
	      },
	      formatResult: function formatResult(res) {
	        return "<span>" + (res.name || res.title) + "</span>";
	      },
	      formatSelection: function formatSelection(res) {
	        return res.name || res.title;
	      },
	      escapeMarkup: function escapeMarkup(m) {
	        return m;
	      }
	    }).on("change", updateButtonVisibility);
	    updateButtonVisibility();
	  },
	
	  batchDelete: function batchDelete() {
	    var _this5 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      return; // User message is set in updateBulkOpVisibility
	    } else {
	      var message = 'Are you sure? This will delete ' + items.length + ' selected POI' + (items.length > 1 ? 's' : '');
	      customConfirm(message, function () {
	        return _this5.grid.deleteSelectedItems();
	      });
	    }
	    return false;
	  },
	
	  combine: function combine() {
	    var _this6 = this;
	
	    var items = this.grid.selectedItems;
	    if (items.length < 2) {
	      return; // User message is set in updateBulkOpVisibility
	    } else {
	      var combinePois = items.map(function (item) {
	        return { id: item.id, name: item.name };
	      });
	      rwgps.clubPoiEditor({
	        poiId: combinePois[0].id,
	        combinePois: combinePois,
	        clubId: this.clubId,
	        onEditSuccess: function onEditSuccess(data) {
	          return _this6.onPoiEditSuccess(data);
	        },
	        tags: this.tags
	      });
	    }
	    return false;
	  },
	
	  batchUpdateTags: function batchUpdateTags(e) {
	    var _this7 = this;
	
	    var tagsStr = this.$('input.tag_names').val();
	    var isAdd = $(e.currentTarget).hasClass('batch_add_tags');
	    var tagAction = isAdd ? 'add' : 'remove';
	
	    if (tagsStr === '') {
	      if (isAdd) customAlert('When adding tags, press &lt;enter&gt; after you type the tag, then click the Add Tags button.');else customAlert('When removing tags, press &lt;enter&gt; after you type the tag, then click the Remove Tags button.');
	      return;
	    }
	
	    this.grid.remoteRequest({
	      url: '/clubs/' + this.clubId + '/points_of_interest/batch_update_tags.json',
	      params: function params(selectedIds) {
	        return { poi_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr };
	      },
	      done: function done(dataView, data) {
	        dataView.beginUpdate();
	        data.points_of_interest.forEach(function (poiData) {
	          var poi = dataView.getItemById(poiData.id);
	          poi.tag_names = poiData.tag_names;
	          dataView.updateItem(poi.id, poi);
	
	          if (isAdd) {
	            poi.tag_names.forEach(function (tag) {
	              if (!_this7.tags.includes(tag)) {
	                _this7.tags.push(tag);
	                _this7.$('select.filter_by_tag').append('<option value="' + tag + '">' + tag + '</option>');
	              }
	            });
	          }
	        });
	        dataView.endUpdate();
	        _this7.$('input.tag_names').select2('val', '');
	      }
	    });
	  },
	
	  onBatchRoutesClick: function onBatchRoutesClick(e) {
	    var remove = $(e.currentTarget).hasClass('batch_remove_routes');
	    var routesButton = $('.CTA.associate-routes');
	    var searchBox = $('#route_search_box');
	
	    routesButton.html((remove ? "Remove From" : "Add To") + ' Routes');
	    routesButton.data('remove', remove);
	    searchBox.select2('val', null);
	  },
	
	  associateRoutes: function associateRoutes(e) {
	    var routeIds = $("#route_search_box").select2('val');
	    var remove = $(e.currentTarget).data('remove');
	
	    this.grid.remoteRequest({
	      url: '/clubs/' + this.clubId + '/batch_associate_poi.json',
	      params: function params(selectedIds) {
	        var result = {
	          poi_ids: selectedIds.join(','),
	          route_ids: routeIds.join(',')
	        };
	        if (remove) {
	          result.remove = 1;
	        }
	        return result;
	      },
	      done: function done() {
	        $.jGrowl('Successfully ' + (remove ? 'removed' : 'added') + ' selected POI ' + (remove ? 'from' : 'to') + ' specified routes.');
	      },
	      fail: function fail(errors) {
	        $.jGrowl('Failed to ' + (remove ? 'removed' : 'added') + ' selected POI ' + (remove ? 'from' : 'to') + ' specified routes: ' + errors.join(', ') + '.');
	      }
	    });
	  },
	
	  updateBulkOpVisibility: function updateBulkOpVisibility() {
	    var grid = this.grid.slickGrid;
	    var data = grid.getData();
	    var items = grid.getSelectedRows().map(function (i) {
	      return data.getItem(i);
	    });
	
	    var noneSelected = items.length == 0 ? "To perform that action, please select at least one POI." : null;
	
	    var shouldDisable = {
	      tags: noneSelected,
	      delete: noneSelected,
	      associate: noneSelected,
	      combine: items.length < 2 ? "To perform that action, please select at least two POIs." : null
	    };
	
	    this.$("[data-bulk-op]").each(function (idx, el) {
	      var elem = $(el);
	      var op = elem.data("bulk-op");
	      var disableMessage = shouldDisable[op];
	
	      if (disableMessage) {
	        elem.addClass("bulk-op-disabled");
	        elem.attr("data-disabled", disableMessage);
	      } else {
	        elem.removeClass("bulk-op-disabled");
	        elem.removeAttr("data-disabled");
	      }
	    });
	
	    this.$('.bulk_op').hide();
	  },
	
	  showDisabledMessage: function showDisabledMessage(e) {
	    var message = $(e.currentTarget).data('disabled');
	    $("#disabled-op-content").html(message);
	    $("#disabled-op").modal("show");
	
	    e.stopImmediatePropagation();
	  },
	
	  /*
	   * misc
	   */
	
	  resizeGrid: function resizeGrid() {
	    // Don't resize anything if sizes have been set by the user
	    if (this.savedSettings.columnWidths) {
	      return;
	    }
	
	    this.grid.slickGrid.resizeCanvas();
	    this.grid.slickGrid.autosizeColumns();
	  },
	
	  increaseGridHeight: function increaseGridHeight() {
	    this.changeGridHeight(100);
	  },
	  decreaseGridHeight: function decreaseGridHeight() {
	    this.changeGridHeight(-100);
	  },
	  changeGridHeight: function changeGridHeight(amount) {
	    var $table = $('#poi_table');
	    var height = $table.height();
	    if (height + amount < 100) return;
	    height += amount;
	    $table.height(height).trigger('resize');
	    Application.setPreference("poi_library_grid_height", height, true);
	  }
	});

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RoutesView = undefined;
	
	var _filtering_grid_with_bulk_operations = __webpack_require__(9);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var RoutesView = exports.RoutesView = Backbone.View.extend({
	  el: '#club-routes',
	  initialize: function initialize() {
	    var _this = this;
	
	    this.editable = this.options.editable;
	    this.tags = this.options.tags;
	    this.data = this.options.data.map(this.cleanRouteData);
	    this.clubId = this.options.clubId;
	    this.eventCount = this.options.eventCount;
	    this.experienceCount = this.options.experienceCount;
	    this.collectionCount = this.options.collectionCount;
	    this.userPinnedRoutes = this.options.userPinnedRoutes || [];
	    rwgps.hasRouteLink = this.options.hasRouteLink || {};
	    this.userDateFormat = this.options.userDateFormat;
	    this.isClubAdmin = this.options.isClubAdmin;
	    this.settings = this.options.settings || {};
	    this.savedSettings = this.settings.saved || {};
	
	    var params = rwgps.Utils.getQueryParameters(window.location.search);
	    var viewingArchives = params.archive === 'true';
	    this.$el.toggleClass('showingArchives', viewingArchives);
	    this.$el.toggleClass('showingLibrary', !viewingArchives);
	
	    this.initSliders();
	    this.initTagInputBoxes();
	    this.initGrid();
	
	    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
	    this.resizeGrid();
	    this.resizeGrid();
	
	    $(window).resize(_.debounce(function () {
	      _this.resizeGrid();
	    }, 100));
	  },
	  events: {
	    // filtering
	    'click .toggle_filters': 'toggleFilters',
	    'keyup .filter_by_name': 'filterTextInputChanged',
	    'keyup .filter_by_location': 'filterTextInputChanged',
	    'change .filter_by_tag': 'filtersChanged',
	    // bulk operations
	    'click .bulk-op-disabled': 'showDisabledMessage',
	    'click .show_bulk_op': 'showBulkOp',
	    'click .batch_set_locality': 'batchSetLocality',
	    'click .backup': 'batchBackup',
	    'click .batch_delete': 'batchDelete',
	    'click .batch_set_visibility': 'batchSetVisibility',
	    'click .plan_ride': 'newEvent',
	    'click .batch_event_add': 'addToEvent',
	    'click .event_add_link': 'loadEvents',
	    'click .create_experience': 'createExperience',
	    'click .experience_add_link': 'loadExperiences',
	    'click .batch_experience_add': 'addToExperience',
	    'click .collection_add_link': 'loadCollections',
	    'click .batch_collection_add': 'addToCollection',
	    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
	    'click .batch_lock': 'batchLock',
	    'click .batch_archive': 'batchArchive',
	    'click .batch_unarchive': 'batchUnarchive',
	    // misc
	    'click .grid_height_increase': 'increaseGridHeight',
	    'click .grid_height_decrease': 'decreaseGridHeight',
	    'mousedown .route-info': 'routeInfo',
	    'mousedown .route-link': 'routeLink',
	    'mouseover .slick-cell': 'linkMousedOver'
	  },
	  initGrid: function initGrid() {
	    var data = this.data,
	        formatters = _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations.formatters;
	
	    // use custom column names for Cascade Bicycle Club
	    var tagColumnName = T.t('tags');
	    var locationColumnName = T.t('location');
	    if (this.clubId == 4) {
	      tagColumnName = "Starting Point";
	      locationColumnName = "Starting City/Sector";
	    }
	
	    // column definitions
	    var columns = [{ id: "name", name: T.t('route_name'), field: "name", sortable: true, formatter: formatters.routeName.bind(this), editor: Slick.Editors.Text }, { id: "tags", name: tagColumnName, field: "tags", sortable: true, formatter: formatters.tags }, { id: "location_str", name: locationColumnName, field: "location_str", sortable: true }, { id: "distance", name: T.t('distance_short') + ' (' + (rwgps.LabelMaker.metric ? 'km' : 'mi') + ')', field: "distance", sortable: true, formatter: formatters.distance }, { id: "elevation_gain", name: T.t('elevation_short') + ' (' + (rwgps.LabelMaker.metric ? 'm' : 'ft') + ')', field: "elevation_gain", sortable: true, formatter: formatters.elevationGain }];
	    if (this.editable) {
	      columns.push({ id: "visibility", name: T.t('privacy'), field: "visibility", sortable: true, formatter: formatters.visibility, editor: Slick.Editors.YesNoFriendsSelect, isClub: true });
	    }
	    columns.push({ id: "updated_at", name: T.t('updated'), field: "updated_at", sortable: true, formatter: formatters.date.bind(this) });
	    if (this.editable) {
	      if (rwgps.clubs.show.featureFlags.includes('content_portal_route_links')) {
	        columns.push({ id: "route_link", name: '', field: "route_link", formatter: formatters.routeLink, resizable: false });
	      }
	      columns.push({ id: "info", name: '', field: "info", formatter: formatters.info, resizable: false });
	    } else {
	      columns.push({ id: "pin", name: '', field: "pin", formatter: formatters.pin.bind(this), resizable: false });
	    }
	
	    var hoverPreviewViewFormatter = function hoverPreviewViewFormatter(row, cell, val, col, item) {
	      return '<a class="row-link showPreview" data-id="' + item.id + '" data-type="route" data-name="' + item.name + '" data-elevationGain="' + item.elevation_gain + '" data-elevationLoss="' + item.elevation_loss + '" data-distance="' + item.distance + '" data-privacyCode="' + item.privacyCode + '" href="/routes/' + item.id + '">View</a>';
	    };
	
	    var columnWidths = Object.assign({
	      tags: 170,
	      location_str: 125,
	      distance: 80,
	      elevation_gain: 75,
	      visibility: 65,
	      updated_at: 90,
	      info: 50,
	      route_link: 50,
	      pin: 50
	    }, this.savedSettings.columnWidths || {});
	    columns.forEach(function (column) {
	      return column.width = columnWidths[column.id];
	    });
	
	    var tagFilter = this.$('.filter_by_tag');
	    var locationFilter = this.$('.filter_by_location');
	    var nameFilter = this.$('.filter_by_name');
	    var filterAccessors = new Map(Object.entries({
	      name: nameFilter.val.bind(nameFilter),
	      location_str: locationFilter.val.bind(locationFilter),
	      tag_names: tagFilter.select2.bind(tagFilter, "val"),
	      distance: this.distSlider,
	      elevation_gain: this.eleSlider
	    }));
	
	    var params = rwgps.Utils.getQueryParameters(window.location.search);
	    var viewingArchives = params.archive === 'true';
	
	    this.grid = new _filtering_grid_with_bulk_operations.FilteringGridWithBulkOperations(data, {
	      target: '#routes_table',
	      columns: columns,
	      editable: this.editable,
	      updatePath: function updatePath(id) {
	        return '/routes/' + id + '/simple_update.json';
	      },
	      updateParam: 'route',
	      viewFormatter: hoverPreviewViewFormatter,
	      ignoreCaseOnSort: ['name', 'location_str'],
	      filterAccessors: filterAccessors,
	      settingsOpts: this.settings.opts
	    });
	
	    // case insensitive sort of concatenated tags
	    this.grid.sortingFn('tags', function (a, b) {
	      var x = (a.tag_names || []).join().toUpperCase(),
	          y = (b.tag_names || []).join().toUpperCase();
	      return x == y ? 0 : x > y ? 1 : -1;
	    });
	
	    this.grid.enableFiltering([{ field: 'name', type: 'string' }, { field: 'location_str', type: 'string' }, { field: 'tag_names', type: 'arraySubset' }, { field: 'distance', type: 'range' }, { field: 'elevation_gain', type: 'range' }, { field: 'archived_at', type: 'function', extra: this.getFilterByViewingArchives(viewingArchives) }]);
	
	    this.grid.enableBulkOperations({
	      bulkUpdateAttributePath: '/routes/batch_set_attr.json',
	      bulkDeletePath: '/routes/batch_destroy.json',
	      idsParam: 'route_ids'
	    });
	
	    if (this.savedSettings.sortCol) {
	      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc);
	    }
	
	    var self = this;
	    this.grid.slickGrid.onSelectedRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	    this.grid.dataView.onRowsChanged.subscribe(function () {
	      return self.updateBulkOpVisibility();
	    });
	  },
	
	  /*
	   * filtering
	   */
	
	  toggleFilters: function toggleFilters() {
	    if (this.$('.toggle_filters .plus').is(':visible')) {
	      this.showFilters();
	    } else {
	      this.hideFilters();
	    }
	  },
	
	  showFilters: function showFilters() {
	    this.$('.toggle_filters').find('.plus').hide().end().find('.minus').show();
	    this.$('.filters').show();
	  },
	
	  hideFilters: function hideFilters() {
	    this.$('.toggle_filters').find('.plus').show().end().find('.minus').hide();
	    this.$('.filters').hide();
	  },
	
	  filterTextInputChanged: function filterTextInputChanged(e) {
	    // clear on escape
	    if (e.which == 27) e.currentTarget.value = '';
	    this.filtersChanged();
	  },
	
	  filtersChanged: function filtersChanged() {
	    if (this.grid) {
	      this.grid.filterInputsChanged();
	    }
	  },
	
	  getFilterByViewingArchives: function getFilterByViewingArchives(viewingArchives) {
	    return function (item) {
	      if (viewingArchives) {
	        return !!item.archived_at;
	      }
	      if (!viewingArchives) {
	        return !item.archived_at;
	      }
	    };
	  },
	
	  makeSlider: function makeSlider(opts) {
	    var self = this;
	    var metric = rwgps.LabelMaker.metric;
	    var sliderValues = opts.values;
	    var labelElem = opts.labelElem;
	    var sliderElem = opts.sliderElem;
	    var maxIndex = 32;
	
	    var units, toMeters, fromMeters;
	    if (opts.longUnits) {
	      units = metric ? 'distance.km' : 'distance.miles';
	      toMeters = rwgps.Convert.longToM;
	      fromMeters = rwgps.Convert.mToLong;
	    } else {
	      units = metric ? 'distance.meters' : 'distance.feet';
	      toMeters = rwgps.Convert.shortToM;
	      fromMeters = rwgps.Convert.mToShort;
	    }
	
	    function changed(newIndexes) {
	      var lowIndex = newIndexes[0] || 0;
	      var highIndex = newIndexes[1] || maxIndex;
	      var lowValue = sliderValues[lowIndex];
	      var highValue = sliderValues[highIndex];
	
	      if (lowIndex == 0 && highIndex == maxIndex) {
	        labelElem.html(T.t(opts.anyLabelKey));
	      } else if (lowIndex == 0) {
	        labelElem.html(T.t('less_than') + ' ' + T.t(units, { count: highValue }));
	      } else if (highIndex == maxIndex) {
	        labelElem.html(T.t('more_than') + ' ' + T.t(units, { count: lowValue }));
	      } else {
	        labelElem.html(lowValue + ' - ' + T.t(units, { count: highValue }));
	      }
	
	      // Don't call filtersChanged until after the current execution stack has
	      // finished. The slider element doesn't get updated with the new indexes
	      // until this function returns, so if we don't wait, when filtersChanged
	      // indirectly calls the accessor below it'll get the old values, not the
	      // new ones
	      setTimeout(function () {
	        return self.filtersChanged();
	      }, 0);
	    }
	
	    sliderElem.slider({
	      range: true,
	      min: 0,
	      max: maxIndex,
	      values: [0, maxIndex],
	      slide: function slide(event, ui) {
	        return changed(ui.values);
	      }
	    });
	
	    changed([0, maxIndex]);
	
	    function accessor(values) {
	      if (values === undefined) {
	        // If no arg has been passed, return the current values
	        var indexes = sliderElem.slider('values') || [];
	        if (indexes.length == 0) {
	          indexes = [0, maxIndex];
	        } else if (indexes.length == 1) {
	          indexes = [indexes[0], maxIndex];
	        }
	        return indexes.map(function (idx) {
	          return sliderValues[idx];
	        }).map(toMeters);
	      } else {
	        if (values.length == 0) {
	          values = [0, Infinity];
	        } else if (values.length == 1) {
	          values = [values[0], Infinity];
	        }
	
	        // Otherwise, set the values on the slider
	        var maxFinite = sliderValues[sliderValues.length - 2];
	        var newIndexes = values.map(fromMeters).map(function (val) {
	          // Find the index of the closest value in sliderValues for each new value
	          var closestIdx = null;
	          var closestDiff = null;
	          if (Number.isFinite(val) && val < maxFinite * 1.5) {
	            sliderValues.forEach(function (sliderValue, idx) {
	              var diff = Math.abs(val - sliderValue);
	              if (closestIdx === null || diff < closestDiff) {
	                closestIdx = idx;
	                closestDiff = diff;
	              }
	            });
	          } else {
	            closestIdx = maxIndex;
	          }
	
	          return closestIdx;
	        });
	
	        if (newIndexes[0] >= maxIndex) {
	          newIndexes[0] = 31;
	        } // Don't allow low end to be infinity
	
	        sliderElem.slider('values', newIndexes);
	        changed(newIndexes);
	      }
	    }
	
	    return accessor;
	  },
	
	  initSliders: function initSliders() {
	    var distVals = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100, 150, 200, 250, 300, 350, 400, 450, Infinity];
	    this.distSlider = this.makeSlider({
	      sliderElem: this.$(".length-slider"),
	      labelElem: this.$(".length-label"),
	      longUnits: true,
	      values: distVals,
	      anyLabelKey: 'any_length'
	    });
	
	    // quadratic easing function with values 0 => 0, 15 => 2500, 31 => 10000
	    var eleVals = [].concat(_toConsumableArray(Array(32).keys())).map(function (_, i) {
	      return Math.round((9.745 * i * i + 20.5 * i) / 100) * 100;
	    });
	    eleVals.push(Infinity);
	    this.eleSlider = this.makeSlider({
	      sliderElem: this.$(".elevation-slider"),
	      labelElem: this.$(".elevation-label"),
	      longUnits: false,
	      values: eleVals,
	      anyLabelKey: 'any_gain'
	    });
	  },
	
	  /*
	   * bulk operations
	   */
	
	  updateBulkOpVisibility: function updateBulkOpVisibility() {
	    var grid = this.grid.slickGrid;
	    var data = grid.getData();
	    var items = grid.getSelectedRows().map(function (i) {
	      return data.getItem(i);
	    });
	
	    var noneSelected = items.length == 0 ? T.t('no_route_selected') : null;
	    var anyLocked = items.some(function (i) {
	      return i.locked;
	    }) ? T.t('routes_are_locked') : null;
	    var noEvents = this.eventCount === 0 ? T.t('no_event_created') : null;
	    var noExperiences = this.experienceCount === 0 ? T.t('no_experience_created') : null;
	    var noCollections = this.collectionCount === 0 ? T.t('no_collection_created') : null;
	
	    var shouldDisable = {
	      tags: noneSelected || anyLocked,
	      locality: noneSelected || anyLocked,
	      visibility: noneSelected || anyLocked,
	      archive: noneSelected,
	      unarchive: noneSelected,
	      delete: noneSelected || anyLocked,
	      backup: noneSelected,
	      event_add: noneSelected || noEvents,
	      experience_add: noneSelected || noExperiences,
	      collection_add: noneSelected || noCollections,
	      lock: items.every(function (i) {
	        return i.locked;
	      }) ? T.t('all_routes_locked') : null,
	      unlock: !anyLocked ? T.t('all_routes_unlocked') : null
	    };
	
	    this.$("[data-bulk-op]").each(function (idx, el) {
	      var elem = $(el);
	      var op = elem.data("bulk-op");
	      var disableMessage = shouldDisable[op];
	
	      if (disableMessage) {
	        elem.addClass("bulk-op-disabled");
	        elem.data("disabled", disableMessage);
	      } else {
	        elem.removeClass("bulk-op-disabled");
	        elem.removeData("disabled");
	        elem.removeAttr("data-disabled");
	      }
	    });
	
	    this.$('.bulk_op').hide();
	  },
	
	  showDisabledMessage: function showDisabledMessage(e) {
	    var message = $(e.currentTarget).data('disabled');
	    $("#disabled-op-content").html(message);
	    $("#disabled-op").modal("show");
	
	    e.stopImmediatePropagation();
	  },
	
	  showBulkOp: function showBulkOp(e) {
	    var bulkOp = $(e.currentTarget).attr('data-bulk-op');
	    var show = !this.$('.bulk_op_' + bulkOp).is(':visible');
	    this.$('.bulk_op').hide();
	    if (show) this.$('.bulk_op_' + bulkOp).show();
	    return false;
	  },
	
	  batchSetLocality: function batchSetLocality() {
	    var locality = this.$('input.new_locality').val();
	    this.grid.setAttributeOnSelectedItems('locality', locality, function (item) {
	      item.location_str = locality;
	    });
	  },
	
	  batchBackup: function batchBackup() {
	    var items = this.grid.selectedItems;
	    if (!items.length) return false;
	
	    customConfirm(T.t('confirm_backup'), function () {
	      var ids = _.map(items, function (_ref) {
	        var id = _ref.id;
	        return id;
	      });
	      $.post('/user_backups', { user_backup: { format: 'json', content: { routes: ids } } }, function (resp) {
	        customAlert(resp.message);
	      });
	    });
	    return false;
	  },
	
	  batchDelete: function batchDelete() {
	    var _this2 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert(T.t('no_route_selected'));
	    } else {
	      customConfirm(T.t('confirm_delete', { count: items.length }), function () {
	        return _this2.grid.deleteSelectedItems();
	      });
	    }
	    return false;
	  },
	
	  batchSetVisibility: function batchSetVisibility() {
	    var visVal = parseInt(this.$('select.visibility').val());
	    this.grid.setAttributeOnSelectedItems('visibility', visVal);
	  },
	
	  batchArchive: function batchArchive() {
	    var _this3 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert(T.t('no_route_selected'));
	    } else {
	      customConfirm(T.t('confirm_archive', { count: items.length }), function () {
	        _this3.grid.setAttributeOnSelectedItems('archived_at', new Date()).always(function () {
	          _this3.grid.setSelectedRows([]);
	        });
	      });
	    }
	    return false;
	  },
	
	  batchUnarchive: function batchUnarchive() {
	    var _this4 = this;
	
	    var items = this.grid.selectedItems;
	    if (!items.length) {
	      customAlert(T.t('no_route_selected'));
	    } else {
	      customConfirm(T.t('confirm_unarchive', { count: items.length }), function () {
	        _this4.grid.setAttributeOnSelectedItems('archived_at', null).always(function () {
	          _this4.grid.setSelectedRows([]);
	        });
	      });
	    }
	    return false;
	  },
	
	  newEvent: function newEvent() {
	    var items = this.grid.selectedItems;
	    rwgps.createEventModal({ initialRouteIds: items.map(function (i) {
	        return i.id;
	      }) });
	  },
	
	  loadEvents: function loadEvents() {
	    var _this5 = this;
	
	    if (this.eventsLoading || this.eventsLoaded) {
	      return false;
	    }
	
	    this.eventsLoading = true;
	    this.eventsLoaded = false;
	
	    // TODO: Loading spinner, if needed
	    $.getJSON('/organizations/' + this.clubId + '/table_events.json?minimal=1').done(function (data) {
	      var eventSelector = _this5.$('input.event_add');
	      var addButton = _this5.$(".batch_event_add");
	
	      addButton.addClass("disabled");
	      data.forEach(function (obj) {
	        obj.text = obj.name;
	      });
	      eventSelector.val('').select2({
	        width: '300px',
	        placeholder: T.t('select_event'),
	        data: data,
	        selectOnBlur: true,
	        formatNoMatches: function formatNoMatches() {
	          return '';
	        }
	      });
	      eventSelector.on("change", function () {
	        var val = eventSelector.select2("val");
	        if (val === '') {
	          addButton.addClass("disabled");
	        } else {
	          addButton.removeClass("disabled");
	        }
	      });
	      _this5.eventsLoaded = true;
	    }).always(function () {
	      _this5.eventsLoading = false;
	    });
	    return false;
	  },
	
	  addToEvent: function addToEvent() {
	    var _this6 = this;
	
	    if (this.addingToEvent) {
	      return;
	    }
	
	    this.addingToEvent = true;
	    var eventSelector = this.$('input.event_add');
	    var eventData = eventSelector.select2("data");
	    var itemCount = this.grid.selectedItems.length;
	
	    if (itemCount === 0) {
	      customAlert(T.t('select_routes_for_event'));
	    } else if (eventData["id"] === '') {
	      customAlert(T.t('select_event_for_routes'));
	    }
	
	    this.grid.remoteRequest({
	      url: '/events/' + eventData["id"] + '/add_routes.json',
	      params: function params(selectedIds) {
	        return { route_ids: selectedIds.join(',') };
	      },
	      done: function done() {
	        $.jGrowl(T.t('added_routes_to_item', { count: itemCount, item_name: eventData["text"] }));
	        eventSelector.select2('val', '');
	        _this6.$('.bulk_op').hide();
	      },
	      always: function always() {
	        _this6.addingToEvent = false;
	      }
	    });
	
	    return false;
	  },
	
	  createExperience: function createExperience() {
	    var items = this.grid.selectedItems;
	    $('#experience_route_ids').val(items.map(function (x) {
	      return x.id;
	    }).join(','));
	    $('#create_experience_form').submit();
	    return false;
	  },
	
	  loadExperiences: function loadExperiences() {
	    var _this7 = this;
	
	    if (this.experiencesLoading || this.experiencesLoaded) {
	      return false;
	    }
	
	    this.experiencesLoading = true;
	    this.expericencsLoaded = false;
	
	    // TODO: Loading spinner, if needed
	    $.getJSON('/organizations/' + this.clubId + '/table_experiences.json?minimal=1').done(function (data) {
	      var experienceSelector = _this7.$('input.experience_add');
	      var addButton = _this7.$(".batch_experience_add");
	
	      addButton.addClass("disabled");
	      data.experiences.forEach(function (obj) {
	        obj.text = obj.name;
	      });
	      experienceSelector.val('').select2({
	        width: '300px',
	        placeholder: T.t('select_experience'),
	        data: data.experiences,
	        selectOnBlur: true,
	        formatNoMatches: function formatNoMatches() {
	          return '';
	        }
	      });
	      experienceSelector.on("change", function () {
	        var val = experienceSelector.select2("val");
	        if (val === '') {
	          addButton.addClass("disabled");
	        } else {
	          addButton.removeClass("disabled");
	        }
	      });
	      _this7.experiencesLoaded = true;
	    }).always(function () {
	      _this7.experiencesLoading = false;
	    });
	    return false;
	  },
	
	  addToExperience: function addToExperience() {
	    var _this8 = this;
	
	    if (this.addingToExperience) {
	      return;
	    }
	
	    this.addingToExperience = true;
	    var experienceSelector = this.$('input.experience_add');
	    var experienceData = experienceSelector.select2("data");
	    var itemCount = this.grid.selectedItems.length;
	
	    if (itemCount === 0) {
	      customAlert(T.t('select_routes_for_experience'));
	    } else if (experienceData["id"] === '') {
	      customAlert(T.t('select_experience_for_routes'));
	    }
	
	    this.grid.remoteRequest({
	      url: '/experiences/' + experienceData["id"] + '/add_routes.json',
	      params: function params(selectedIds) {
	        return { route_ids: selectedIds.join(',') };
	      },
	      done: function done() {
	        $.jGrowl(T.t('added_routes_to_item', { count: itemCount, item_name: experienceData["text"] }));
	        experienceSelector.select2('val', '');
	        _this8.$('.bulk_op').hide();
	      },
	      always: function always() {
	        _this8.addingToExperience = false;
	      }
	    });
	    return false;
	  },
	
	  loadCollections: function loadCollections() {
	    var _this9 = this;
	
	    if (this.collectionsLoading || this.collectionsLoaded) {
	      return false;
	    }
	
	    this.collectionsLoading = true;
	    this.collectionsLoaded = false;
	
	    $.getJSON('/organizations/' + this.clubId + '/table_collections.json?minimal=1').done(function (data) {
	      var collectionSelector = _this9.$('input.collection_add');
	      var addButton = _this9.$(".batch_collection_add");
	
	      addButton.addClass("disabled");
	      data.collections.forEach(function (obj) {
	        obj.text = obj.title;
	      });
	      collectionSelector.val('').select2({
	        width: '300px',
	        placeholder: T.t('select_collection'),
	        data: data.collections,
	        selectOnBlur: true,
	        formatNoMatches: function formatNoMatches() {
	          return '';
	        }
	      });
	      collectionSelector.on("change", function () {
	        var val = collectionSelector.select2("val");
	        if (val === '') {
	          addButton.addClass("disabled");
	        } else {
	          addButton.removeClass("disabled");
	        }
	      });
	      _this9.collectionsLoaded = true;
	    }).always(function () {
	      _this9.collectionsLoading = false;
	    });
	    return false;
	  },
	
	  addToCollection: function addToCollection() {
	    var _this10 = this;
	
	    if (this.addingToCollection) {
	      return;
	    }
	
	    this.addingToCollection = true;
	    var collectionSelector = this.$('input.collection_add');
	    var collectionData = collectionSelector.select2("data");
	    var itemCount = this.grid.selectedItems.length;
	
	    if (itemCount === 0) {
	      customAlert(T.t('select_routes_for_collection'));
	    } else if (collectionData["id"] === '') {
	      customAlert(T.t('select_collection_for_routes'));
	    }
	
	    this.grid.remoteRequest({
	      url: '/collections/' + collectionData["id"] + '/add_routes.json',
	      params: function params(selectedIds) {
	        return { route_ids: selectedIds.join(',') };
	      },
	      done: function done() {
	        $.jGrowl(T.t('added_routes_to_item', { count: itemCount, item_name: collectionData["text"] }));
	        collectionSelector.select2('val', '');
	        _this10.$('.bulk_op').hide();
	      },
	      always: function always() {
	        _this10.addingToCollection = false;
	      }
	    });
	    return false;
	  },
	
	  initTagInputBoxes: function initTagInputBoxes() {
	    var _this11 = this;
	
	    this.$('.tag_select2_input').val('').select2({
	      openOnEnter: false,
	      width: '150px',
	      placeholder: T.t('route_tags'),
	      tokenSeparators: [','],
	      tags: this.tags,
	      selectOnBlur: true,
	      formatNoMatches: function formatNoMatches() {
	        return '';
	      },
	      createSearchChoice: function createSearchChoice(term) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this11.tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	
	            if (value.toUpperCase() === term.toUpperCase()) {
	              return { id: value, text: value };
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return { id: term, text: term };
	      }
	    });
	  },
	
	  batchLock: function batchLock(e) {
	    var bulkOp = $(e.currentTarget).attr('data-bulk-op');
	
	    this.grid.remoteRequest({
	      url: '/routes/batch_' + bulkOp + '.json',
	      params: function params(selectedIds) {
	        return { route_ids: selectedIds.join(',') };
	      },
	      done: function done(dataView, data) {
	        dataView.beginUpdate();
	        data.routes.forEach(function (routeData) {
	          var route = dataView.getItemById(routeData.id);
	          route.locked = routeData.locked;
	          dataView.updateItem(route.id, route);
	        });
	        dataView.endUpdate();
	      }
	    });
	  },
	
	  batchUpdateTags: function batchUpdateTags(e) {
	    var _this12 = this;
	
	    var tagsStr = this.$('input.tag_names').val();
	    var isAdd = $(e.currentTarget).hasClass('batch_add_tags');
	    var tagAction = isAdd ? 'add' : 'remove';
	
	    if (tagsStr === '') {
	      if (isAdd) customAlert(T.t('tag_add_help'));else customAlert(T.t('tag_remove_help'));
	      return;
	    }
	
	    this.grid.remoteRequest({
	      url: '/routes/batch_update_tags.json',
	      params: function params(selectedIds) {
	        return { route_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr };
	      },
	      done: function done(dataView, data) {
	        dataView.beginUpdate();
	        data.routes.forEach(function (routeData) {
	          var route = dataView.getItemById(routeData.id);
	          route.tag_names = routeData.tag_names;
	          dataView.updateItem(route.id, route);
	
	          if (isAdd) {
	            route.tag_names.forEach(function (tag) {
	              if (!_this12.tags.includes(tag)) {
	                _this12.tags.push(tag);
	                _this12.$('select.filter_by_tag').append('<option value="' + tag + '">' + tag + '</option>');
	              }
	            });
	          }
	        });
	        dataView.endUpdate();
	        _this12.$('input.tag_names').select2('val', '');
	      }
	    });
	  },
	
	  updateRoute: function updateRoute(routeId, routeData, doneFunc) {
	    var self = this;
	    this.grid.remoteRequest({
	      url: '/routes/' + routeId + '/club_update.json',
	      params: routeData,
	      done: function done(dataView, data) {
	        // Merge the new data into our existing object
	        var route = Object.assign(dataView.getItemById(data.id), self.cleanRouteData(data));
	        dataView.updateItem(route.id, route);
	        if (doneFunc) {
	          doneFunc();
	        }
	      }
	    });
	  },
	
	  cleanRouteData: function cleanRouteData(data) {
	    var route = Object.assign({}, data);
	    route.created_at = rwgps.DateExt.parse(route.created_at);
	    route.updated_at = rwgps.DateExt.parse(route.updated_at);
	    route.location_str = [route.locality, route.administrative_area].filter(Boolean).join(', ');
	
	    return route;
	  },
	
	  /*
	   * misc
	   */
	
	  linkMousedOver: function linkMousedOver(e) {
	    var links = $(e.currentTarget).find('.showPreview');
	    if (links.length) {
	      var link = links[0];
	      if (link.dataset.type === 'route' && link.dataset.id) {
	        if (this._routeCard) {
	          // if we are moving our cursor from the cell to the link, even though the targets are changing, lets just keep the previous one active
	          if ($(e.target).parents().hasClass('tippy-active') || $(e.target).hasClass('tippy-active')) {
	            return false;
	          }
	
	          // destroy a previous tippy
	          if (this._routeCard.previousTarget._tippy && !this._routeCard.previousTarget._tippy.state.destroyed) {
	            this._routeCard.unmountComponent();
	          }
	        }
	        var renderTarget = document.getElementById('route_hover_preview');
	        this._routeCard = rwgps.routeHoverCard(renderTarget, Object.assign({ target: e.currentTarget }, link.dataset));
	        this._routeCard.previousTarget = e.currentTarget;
	      }
	    }
	  },
	
	  resizeGrid: function resizeGrid() {
	    // Don't resize anything if sizes have been set by the user
	    if (this.savedSettings.columnWidths) {
	      return;
	    }
	
	    var size = 0;
	    var nameItem = void 0;
	    _.each(this.grid.slickGrid.getColumns(), function (item) {
	      if (item.id == "name") nameItem = item;else size += item.width;
	    });
	    nameItem.width = this.grid.slickGrid.getViewport().rightPx - size;
	    this.grid.slickGrid.resizeCanvas();
	    this.grid.slickGrid.autosizeColumns();
	  },
	  increaseGridHeight: function increaseGridHeight() {
	    this.changeGridHeight(100);
	  },
	  decreaseGridHeight: function decreaseGridHeight() {
	    this.changeGridHeight(-100);
	  },
	  routeInfo: function routeInfo(e) {
	    var routeId = $(e.currentTarget).data('id');
	    $.get("/routes/" + routeId + "/club_edit", function (resp) {
	      $('#info-modal').html(resp).modal();
	    });
	  },
	  routeLink: function routeLink(e) {
	    var routeId = $(e.currentTarget).data('id');
	    $.get("/routes/" + routeId + "/edit_route_link", function (resp) {
	      $('#route-link-modal').html(resp).modal();
	    });
	  },
	  changeGridHeight: function changeGridHeight(amount) {
	    var $table = $('#routes_table');
	    var height = $table.height();
	    if (height + amount < 100) return;
	    height += amount;
	    $table.height(height).trigger('resize');
	    Application.setPreference("routes_grid_height", height, true);
	  }
	});

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _events_list_view = __webpack_require__(122);
	
	var _routes_view = __webpack_require__(125);
	
	var _club_members_view = __webpack_require__(120);
	
	var _embed_library_view = __webpack_require__(121);
	
	var _experiences_view = __webpack_require__(123);
	
	var _poi_library_view = __webpack_require__(124);
	
	rwgps.clubs.reactBindings = {};['events', 'routes', 'embed_library', 'experiences', 'poi_library', 'members', 'messages', 'settings'].forEach(function (page) {
	  rwgps.clubs.reactBindings[page] = {
	    onMount: function onMount(el) {
	      el.innerHTML = window.clubPages[page];
	      rwgps.clubs.show.onMount(page);
	    },
	    onUnmount: function onUnmount(el) {
	      rwgps.clubs.show.onUnmount(page);
	      el.innerHTML = '';
	    }
	  };
	});
	
	rwgps.ns('clubs.show', function () {
	  var _this = this;
	
	  var ns = this,
	      MessageCommentView,
	      ClubMessagesView,
	      ClubMessageView,
	      ClubEventsView,
	      routesView;
	
	  var params = rwgps.Utils.getQueryParameters(window.location.search);
	  var viewingArchives = params.archive === 'true';
	
	  ns.onMount = function (page) {
	    $(function () {
	      switch (page) {
	        case 'events':
	          ns.eventsView = new ClubEventsView();
	          break;
	        case 'routes':
	          $.get('/clubs/' + rwgps.clubs.show.clubId + '/table_routes.json' + (viewingArchives ? '?archived=true' : ''), function (routes) {
	            routesView = new _routes_view.RoutesView({
	              clubId: ns.clubId,
	              editable: ns.canManage,
	              data: routes,
	              tags: ns.routeTags,
	              userDateFormat: ns.userDateFormat,
	              userPinnedRoutes: ns.userPinnedRoutes,
	              hasRouteLink: Object.fromEntries(ns.hasRouteLink.map(function (key) {
	                return [key, true];
	              })),
	              settings: tableSettings("routes", ns.canManage),
	              isClubAdmin: ns.isClubAdmin,
	              eventCount: ns.eventCount,
	              experienceCount: ns.experienceCount,
	              collectionCount: ns.collectionCount
	            });
	            ns.routesView = routesView;
	            routesView.grid.onRequestError(onError.bind(_this));
	          });
	          break;
	        case 'embed_library':
	          $.get('/clubs/' + rwgps.clubs.show.clubId + '/table_embeds.json', function (resp) {
	            new _embed_library_view.EmbedLibraryView({
	              clubId: ns.clubId,
	              data: resp.embeds,
	              editable: ns.canManage,
	              userDateFormat: ns.userDateFormat,
	              settings: tableSettings("embed_library", true)
	            });
	          });
	          break;
	        case 'experiences':
	          $.get('/clubs/' + rwgps.clubs.show.clubId + '/table_experiences.json' + (viewingArchives ? '?archived=true' : ''), function (resp) {
	            new _experiences_view.ExperiencesView({
	              clubId: ns.clubId,
	              data: resp.experiences,
	              editable: ns.canManage,
	              userDateFormat: ns.userDateFormat,
	              settings: tableSettings("experiences", true)
	            });
	          });
	          break;
	        case 'poi_library':
	          $.get('/clubs/' + rwgps.clubs.show.clubId + '/table_pois.json', function (resp) {
	            new _poi_library_view.PoiLibraryView({
	              clubId: ns.clubId,
	              data: resp.pois,
	              editable: ns.canManage,
	              poiIcons: resp.poiIcons || [],
	              tags: resp.poiTags || [],
	              settings: tableSettings("poi_library", true)
	            });
	          });
	          break;
	        case 'members':
	          if (ns.canManageMembers) {
	            $.get('/clubs/' + rwgps.clubs.show.clubId + '/table_members.json', function (members) {
	              ns.membersView = new _club_members_view.ClubMembersView({
	                clubId: ns.clubId,
	                currentMember: ns.currentMember,
	                baseCurrentMember: ns.baseCurrentMember,
	                data: members,
	                settings: tableSettings("members", true)
	              });
	              ns.membersView.grid.onRequestError(onError.bind(_this));
	            });
	          }
	          break;
	        case 'messages':
	          new ClubMessagesView();
	          break;
	        case 'settings':
	          break;
	      }
	    });
	  };
	
	  ns.onUnmount = function (page) {
	    switch (page) {
	      case 'events':
	        ns.eventsView = null;
	        break;
	      case 'routes':
	        ns.routesView = null;
	        break;
	      case 'members':
	        break;
	      case 'messages':
	        break;
	      case 'settings':
	        break;
	    }
	  };
	
	  ns.init = function () {
	    $(function () {
	      if (!ns.tableSettings) {
	        ns.tableSettings = {};
	      }
	
	      attachRouteInfoModalEvents();
	
	      $("#plan-ride-container").on("show.bs.modal", function () {
	        resetNewEventForm();
	      });
	      $("#new-event-container").on("show.bs.modal", function () {
	        resetSimpleEventForm();
	      });
	
	      $('#edit-club-message-modal').on('hidden.bs.modal', function () {
	        $('#edit-club-message-modal').removeData('bs.modal');
	      });
	
	      $('#sendMessageModal').on('shown.bs.modal', function () {
	        $('#quick_message').on('submit', function () {
	          $('#sendMessageModal').modal('hide');
	        });
	      });
	
	      $('#sendMessageModal').on('hidden.bs.modal', function () {
	        $('#sendMessageModal').removeData('bs.modal');
	      });
	    });
	  };
	
	  function resetSimpleEventForm() {
	    $('#simple_event_start_time').hide();
	    $('#simple_event_end_time').hide();
	    $('#new-event-container input[type=checkbox].all_day').attr('checked', true);
	  }
	
	  function resetNewEventForm() {
	    $('#event_start_time').hide();
	    $('#event_end_time').hide();
	    $('#plan-ride-container input[type=checkbox].all_day').attr('checked', true);
	    $('#plan-ride-container input[type=checkbox].auto_expire_participants').attr('checked', false);
	    $('#plan-ride-container .participant_duration_options').hide();
	    $('#plan-ride-container input[type=checkbox].request_email').attr('checked', false);
	  }
	
	  function attachRouteInfoModalEvents() {
	    $('#info-modal').on('click', '.removeItem', function () {
	      var element = this.parentElement;
	      $(element).addClass('hide');
	      var item_id = $(this).attr('data-id');
	      var item_type = $(this).attr('data-type');
	      var fieldValue = document.getElementById('remove_' + item_type + '_ids').value;
	      if (!fieldValue) {
	        fieldValue = [];
	      } else {
	        fieldValue = fieldValue.split(',');
	      }
	      var updatedValue = fieldValue.concat(item_id);
	      document.getElementById('remove_' + item_type + '_ids').value = updatedValue;
	      return false;
	    });
	    $('#info-modal').on('submit', 'form', function () {
	      var routeId = $(this).attr('data-route-id');
	      var params = $(this).serialize();
	      routesView.updateRoute(routeId, params, function () {
	        $.jGrowl('Successfully updated.');
	        $("#info-modal").modal('hide');
	      });
	      return false;
	    });
	  }
	
	  function replacer(match, p1, p2, p3) {
	    return '<a href="' + p1 + '://' + p3 + '" target="_blank" rel="nofollow">' + p3 + '</a>';
	  }
	
	  MessageCommentView = Backbone.View.extend({
	    template: _.template($('#messageCommentsTemplate').html()),
	    tagName: "li",
	    initialize: function initialize() {
	      this.render();
	    },
	    events: {
	      'mouseover .comment': 'showDeleteIcon',
	      'mouseleave .comment': 'hideDeleteIcon',
	      'click .delete-comment': 'destroyComment'
	    },
	    render: function render() {
	      var comment = this.options.comment.comment.replace(/(\n)/g, " <br> "),
	          updatedComment = comment.replace(/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/, replacer);
	
	      this.options.comment.comment = updatedComment;
	      this.$el.html(this.template({ comment: this.options.comment, message: this.options.message }));
	      return this;
	    },
	    showDeleteIcon: function showDeleteIcon() {
	      if (rwgps.config.currentUser && (this.options.comment.user_id == rwgps.config.currentUser.id || ns.canManageMessages)) {
	        this.$('.delete-comment').show();
	      }
	    },
	    hideDeleteIcon: function hideDeleteIcon() {
	      this.$('.delete-comment').hide();
	    },
	    destroyComment: function destroyComment() {
	      // TODO: This should be consolidated with other comment requests
	      var id = this.options.comment.id,
	          self = this;
	      customConfirm("Are you sure you want to delete this comment?", function () {
	        $.ajax({
	          type: 'POST',
	          url: '/comments/' + id + '.json',
	          data: { _method: 'delete' },
	          dataType: 'json',
	          success: function success() {
	            $.jGrowl("Successfully deleted");
	            self.options.message.comment_count--;
	            self.options.messageView.renderCommentsCount();
	            $(self.el).html('');
	          },
	          error: function error() {
	            $.jGrowl("There was an error deleting this comment");
	          }
	        });
	      });
	    }
	  });
	
	  ClubMessageView = Backbone.View.extend({
	    template: _.template($('#clubMessageTemplate').html()),
	    tagName: "li",
	    className: 'club_message',
	    initialize: function initialize() {
	      this.render();
	    },
	    events: {
	      'click a.show_comments': 'displayComments',
	      'submit': 'addComment',
	      'click .edit_message': 'editMessage',
	      'click .show_reply': 'showReply'
	    },
	    render: function render() {
	      var messageContent = this.options.message.content.replace(/(\n)/g, " <br> "),
	          updatedContent = messageContent.replace(/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/, replacer);
	      this.options.message.content = updatedContent;
	      this.$el.html(this.template({ message: this.options.message }));
	      this.renderCommentsCount();
	      return this;
	    },
	    renderCommentsCount: function renderCommentsCount() {
	      var showNumComments = this.$('.comment_show');
	      if (this.options.message.comment_count == 0) {
	        showNumComments.html('').closest('li').css({ display: 'none' });
	      } else if (this.options.message.comment_count == 1) {
	        showNumComments.html(' 1 Comment ').css({ display: 'inline-block' });
	      } else {
	        showNumComments.html(' ' + this.options.message.comment_count + ' Comments ').css({ display: 'inline-block' });
	      }
	    },
	    editMessage: function editMessage(e) {
	      $.get($(e.currentTarget).attr('href'), function (resp) {
	        $('#edit-club-message-modal').html(resp).modal();
	      });
	
	      return false;
	    },
	    showReply: function showReply() {
	      this.$('.add_comment').toggle();
	    },
	    addComment: function addComment() {
	      // TODO: This should be consolidated with other comment requests
	      var $commentsList = this.$('.message-comments-list'),
	          comment = this.$('textarea.new_comment').val(),
	          that = this;
	      if (comment != '') {
	        $.ajax({
	          url: '/comments.json',
	          type: 'POST',
	          dataType: 'json',
	          data: { comment: comment, response_as_data: true, parent_id: this.options.message.id, parent_type: "club_message" },
	          success: function success(response) {
	            that.options.message.comment_count++;
	            that.renderCommentsCount();
	            var item = new MessageCommentView({ comment: response, message: that.options.message, messageView: that });
	            $commentsList.append(item.$el);
	          },
	          error: function error() {
	            $.jGrowl("There was an error saving your comment");
	          }
	        });
	      }
	      $commentsList.show();
	      this.$('textarea.new_comment').val('');
	      return false;
	    },
	    displayComments: function displayComments() {
	      var $commentsList = this.$('.message-comments-list');
	      var that = this;
	      if ($commentsList.is(":visible")) {
	        $commentsList.hide();
	      } else {
	        $commentsList.html('');
	        $.get('/comments.json', { parent_type: "club_message", parent_id: this.options.message.id }, function (comments) {
	          comments.comments.forEach(function (comment) {
	            var item = new MessageCommentView({ comment: comment, message: that.options.message, messageView: that });
	            $commentsList.append(item.$el);
	          });
	        });
	        $commentsList.show();
	      }
	    }
	  });
	
	  ClubMessagesView = Backbone.View.extend({
	    el: '#club-messages',
	    initialize: function initialize() {
	      this.render();
	    },
	    render: function render() {
	      var messages = ns.clubMessages,
	          $messagesList = this.$('#club-message-list');
	      messages = messages.sort(function (a, b) {
	        a = new Date(a.created_at);
	        b = new Date(b.created_at);
	        return a > b ? -1 : a < b ? 1 : 0;
	      });
	
	      messages.forEach(function (message) {
	        var item = new ClubMessageView({ message: message });
	        $messagesList.append(item.$el);
	      });
	      return this;
	    }
	  });
	
	  ClubEventsView = Backbone.View.extend({
	    el: '#club-events',
	    initialize: function initialize() {
	      var params = rwgps.Utils.getQueryParameters(window.location.search);
	      var listMode = params.display === 'list';
	      var viewingArchives = params.archive === 'true';
	
	      this.$el.toggleClass('showingArchives', viewingArchives);
	      this.$el.toggleClass('showingLibrary', !viewingArchives);
	
	      if ($('#event_list').is(':visible')) {
	        this.initListView();
	      } else if (listMode) {
	        this.showListView();
	      }
	      window.Clubs.Calendar.init();
	    },
	    events: {
	      'click .toggle-other-events': 'toggleOther',
	      'click .show-tbd-events': 'showTbdEvents',
	      'click .toggle_list_view': 'showListView',
	      'click .toggle_calendar_view': 'showCalendarView',
	      'click .create_event': 'createEvent'
	    },
	    createEvent: function createEvent() {
	      rwgps.createEventModal();
	    },
	    initListView: function initListView() {
	      var _this2 = this;
	
	      var params = rwgps.Utils.getQueryParameters(window.location.search);
	      var viewingArchives = params.archive === 'true';
	
	      $.get('/clubs/' + rwgps.clubs.show.clubId + '/table_events.json' + (viewingArchives ? '?archived=true' : ''), function (events) {
	        _this2.listView = new _events_list_view.EventsListView({
	          editable: ns.canManage,
	          data: events,
	          userDateFormat: ns.userDateFormat,
	          settings: tableSettings("events", ns.canManage)
	        });
	
	        _this2.listView.grid.onRequestError(onError.bind(_this2));
	      });
	    },
	    showTbdEvents: function showTbdEvents() {
	      $('.tbd_events').toggle();
	    },
	    toggleOther: function toggleOther() {
	      $('#other-events').toggle();
	    },
	    showListView: function showListView() {
	      $('#event_calendar').hide();
	      $('#event_list').show();
	      $('.toggle_list_view').button('toggle');
	      if (!this.listView) {
	        this.initListView();
	      }
	    },
	    showCalendarView: function showCalendarView() {
	      $('#event_list').hide();
	      $('#event_calendar').show();
	    }
	
	  });
	
	  function tableSettings(name) {
	    var manager = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var tableName = (manager ? 'manage' : 'view') + '-' + name;
	    var saveOpts = null;
	
	    if (ns.saveTableSettings) {
	      saveOpts = {
	        url: '/clubs/' + ns.clubId + '/update_table_settings',
	        method: 'PUT',
	        name: tableName
	      };
	    }
	
	    return {
	      saved: ns.tableSettings[tableName],
	      opts: saveOpts
	    };
	  }
	
	  function onError(errors) {
	    var message = "";
	    if (errors.length > 0) {
	      message = errors.join("<br>");
	    } else {
	      message = "There was an error performing the requested operation";
	    }
	
	    $("#errors-content").html(message + "<br>");
	    $("#errors").modal("show");
	  }
	});

/***/ })

});


// WEBPACK FOOTER //
// clubs-show-0e76535e4b67b0f0a28b-bundle.js